import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { createProduto, getProdutos, getProduto, updateProduto, deleteProduto, getClientes, getCategorias, createCategoria, deleteCategoria, getSubcategorias, getSubcategoriasByCategoria, createSubcategoria, deleteSubcategoria, getProdutoCores, addProdutoCor, updateProdutoCoresOrder, deleteProdutoCor, getPrazoConfig, updatePrazoConfig, getPrazoAdminStats, getPrazoVendasAdmin, getPedidosAdmin, getPedidosAdminStats, updatePedidoStatus, createPedidoAdmin, getEstoque, updateEstoque, getMovimentacoesEstoque, ajustarEstoqueLote, uploadCarouselImage, checkApiHealth, getCarouselInicial, saveCarouselInicial as saveCarouselInicialApi } from '../services/api';
import { getImageUrl, PLACEHOLDER_IMAGE } from '../utils/imageUrl';
import CarouselImageCropModal from '../components/CarouselImageCropModal';
import AreaPrazoAdmin from '../components/AreaPrazoAdmin';
import './DashboardAdmin.css';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const normalizeText = (value) => String(value || '')
  .trim()
  .toLowerCase()
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .replace(/\s+/g, '');

const isColoracaoNome = (nome) => {
  const n = normalizeText(nome);
  return n === 'coloracao' || n === 'coloring';
};

/** Converte total vindo da API (número ou string DECIMAL) para float seguro. */
const parseMoney = (value) => {
  if (value == null || value === '') return 0;
  if (typeof value === 'number') return Number.isFinite(value) ? value : 0;
  if (typeof value === 'string') {
    const t = value.trim().replace(/\s/g, '');
    if (!t) return 0;
    const normalized = t.includes(',') ? t.replace(/\./g, '').replace(',', '.') : t;
    const n = parseFloat(normalized);
    return Number.isFinite(n) ? n : 0;
  }
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
};

/** Data local (YYYY-MM-DD) do instante da venda, alinhada aos campos type="date". */
const dataLocalVendaAprazo = (createdAt) => {
  if (createdAt == null || createdAt === '') return null;
  const d = new Date(createdAt);
  if (Number.isNaN(d.getTime())) return null;
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

const filtrarVendasAprazoNoPeriodo = (lista, dataIni, dataFim) => {
  if (!Array.isArray(lista) || !dataIni || !dataFim) return [];
  return lista.filter((v) => {
    const k = dataLocalVendaAprazo(v.created_at);
    return k != null && k >= dataIni && k <= dataFim;
  });
};

const DashboardAdmin = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('dashboard');
  const [formData, setFormData] = useState({
    nome: '',
    descricao: '',
    preco: '',
    preco_anterior: '',
    categoria_id: '',
    subcategoria_id: '',
    quantidade: ''
  });
  const [fotos, setFotos] = useState([]);
  const [fotosExistentes, setFotosExistentes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [produtos, setProdutos] = useState([]);
  const [loadingProdutos, setLoadingProdutos] = useState(false);
  const [estoqueProdutos, setEstoqueProdutos] = useState([]);
  const [loadingEstoque, setLoadingEstoque] = useState(false);
  const [movimentacoesEstoque, setMovimentacoesEstoque] = useState([]);
  const [loadingMovEstoque, setLoadingMovEstoque] = useState(false);
  const [estoqueSelecionados, setEstoqueSelecionados] = useState({});
  const [motivoLote, setMotivoLote] = useState('');
  const [clientes, setClientes] = useState([]);
  const [loadingClientes, setLoadingClientes] = useState(false);
  const [categorias, setCategorias] = useState([]);
  const [loadingCategorias, setLoadingCategorias] = useState(false);
  const [carouselProdutos, setCarouselProdutos] = useState([]);
  const [categoriaForm, setCategoriaForm] = useState({
    nome: '',
    descricao: '',
    icone: ''
  });
  const [subcategorias, setSubcategorias] = useState([]);
  const [subcategoriasPorCategoria, setSubcategoriasPorCategoria] = useState([]);
  const [subcategoriaForm, setSubcategoriaForm] = useState({ categoria_id: '', nome: '' });
  const [editingProduto, setEditingProduto] = useState(null);
  const [produtoCores, setProdutoCores] = useState([]);
  const [corForm, setCorForm] = useState({ descricao_cor: '', foto: null });
  const [coresPendentes, setCoresPendentes] = useState([]);
  const [corPreviewUrl, setCorPreviewUrl] = useState(null);
  const corFotoInputRef = React.useRef(null);
  const corDescricaoInputRef = React.useRef(null);
  const [loadingCor, setLoadingCor] = useState(false);
  const [stats, setStats] = useState({
    totalProdutos: 0,
    totalClientes: 0,
    produtosAtivos: 0,
    produtosOferta: 0
  });
  const [prazoConfig, setPrazoConfig] = useState({ maxParcelas: 3, juros: {} });
  const [pedidos, setPedidos] = useState([]);
  const [loadingPedidos, setLoadingPedidos] = useState(false);
  const [periodoGrafico, setPeriodoGrafico] = useState('mes');
  const [loadingStatsVendas, setLoadingStatsVendas] = useState(false);
  const [statsVendas, setStatsVendas] = useState({
    totalVendas: 0,
    totalPedidos: 0,
    ticketMedio: 0,
    serie: [],
    topProdutos: [],
    topClientes: []
  });
  const [periodoGraficoAprazo, setPeriodoGraficoAprazo] = useState('mes');
  const [loadingStatsAprazo, setLoadingStatsAprazo] = useState(false);
  const [statsAprazo, setStatsAprazo] = useState({
    totalPagamentosRecebidos: 0,
    totalNovasVendasValor: 0,
    vendasRegistradasNoPeriodo: 0,
    saldoEmAberto: 0,
    vendasAbertasCount: 0,
    seriePagamentos: [],
    serieNovasVendas: [],
    porMetodoPagamento: [],
    topClientesRecebimentos: [],
    topProdutos: []
  });
  const [painelPeriodoVendasAprazoAberto, setPainelPeriodoVendasAprazoAberto] = useState(false);
  const [periodoVendasAprazoIni, setPeriodoVendasAprazoIni] = useState('');
  const [periodoVendasAprazoFim, setPeriodoVendasAprazoFim] = useState('');
  const [vendasAprazoListaPeriodo, setVendasAprazoListaPeriodo] = useState([]);
  const [loadingVendasAprazoPeriodo, setLoadingVendasAprazoPeriodo] = useState(false);
  const [loadingPdfAprazoPeriodo, setLoadingPdfAprazoPeriodo] = useState(false);
  const [vendasAprazoPeriodoConsultado, setVendasAprazoPeriodoConsultado] = useState(false);
  const periodoVendasAprazoRef = useRef({ ini: '', fim: '' });
  const [pedidoSelecionado, setPedidoSelecionado] = useState(null);
  const [novasCompras, setNovasCompras] = useState(0);
  const [ultimoPedidoVistoId, setUltimoPedidoVistoId] = useState(() => Number(localStorage.getItem('adminUltimoPedidoVistoId') || 0));
  const [vendaStep, setVendaStep] = useState(null);
  const [clienteVenda, setClienteVenda] = useState(null);
  const [carrinhoVenda, setCarrinhoVenda] = useState([]);
  const [produtosVenda, setProdutosVenda] = useState([]);
  const [loadingProdutosVenda, setLoadingProdutosVenda] = useState(false);
  const [pagamentoTipo, setPagamentoTipo] = useState('normal');
  const [formaNormal, setFormaNormal] = useState('pix');
  const [prazoEntrada, setPrazoEntrada] = useState(0);
  const [prazoFormaEntrada, setPrazoFormaEntrada] = useState('pix');
  const [prazoParcelas, setPrazoParcelas] = useState(1);
  const [prazoDataPrimeira, setPrazoDataPrimeira] = useState('');
  const [loadingVenda, setLoadingVenda] = useState(false);
  const [filtroCategoriaVenda, setFiltroCategoriaVenda] = useState('');
  const [filtroBuscaVenda, setFiltroBuscaVenda] = useState('');
  const [qtyParaAdicionarVenda, setQtyParaAdicionarVenda] = useState({});
  const [categoriasVenda, setCategoriasVenda] = useState([]);
  const [buscaClienteVenda, setBuscaClienteVenda] = useState('');
  const [carouselInicial, setCarouselInicial] = useState({ interval: 5000, slides: [] });
  const [savingCarousel, setSavingCarousel] = useState(false);
  const [cropModalOpen, setCropModalOpen] = useState(false);
  const [cropModalSlideIndex, setCropModalSlideIndex] = useState(null);
  const [cropModalSrc, setCropModalSrc] = useState(null);
  const [uploadingCarouselImage, setUploadingCarouselImage] = useState(false);
  const [uploadFullForSlideIndex, setUploadFullForSlideIndex] = useState(null);
  const [apiReachable, setApiReachable] = useState(null);
  const [savingEstoqueProdutoId, setSavingEstoqueProdutoId] = useState(null);
  const [savingLote, setSavingLote] = useState(false);
  const carouselFileInputRef = React.useRef(null);
  const carouselUploadFullRef = React.useRef(null);
  const CAROUSEL_DIMENSOES = '1920×500';

  const cliente = JSON.parse(localStorage.getItem('cliente') || '{}');
  const token = localStorage.getItem('token');
  const isCompraCliente = (pedido) => !pedido?.created_by_admin;

  const getMaiorPedidoClienteId = (lista) => {
    if (!Array.isArray(lista) || lista.length === 0) return 0;
    return lista.reduce((maiorId, pedido) => {
      if (!isCompraCliente(pedido)) return maiorId;
      const id = Number(pedido?.id) || 0;
      return id > maiorId ? id : maiorId;
    }, 0);
  };

  const marcarComprasComoVistas = (lista) => {
    const maiorId = getMaiorPedidoClienteId(lista);
    localStorage.setItem('adminUltimoPedidoVistoId', String(maiorId));
    setUltimoPedidoVistoId(maiorId);
    setNovasCompras(0);
  };

  const loadCarouselInicial = () => {
    getCarouselInicial()
      .then((res) => {
        const data = res.data || {};
        const interval = data.interval != null ? Math.max(2000, Math.min(60000, Number(data.interval))) : 5000;
        const slides = Array.isArray(data.slides) ? data.slides : [];
        setCarouselInicial({ interval, slides });
      })
      .catch(() => setCarouselInicial({ interval: 5000, slides: [] }));
  };

  const handleSaveCarouselInicial = async () => {
    const toSave = {
      interval: carouselInicial.interval != null ? carouselInicial.interval : 5000,
      slides: (carouselInicial.slides || []).map((s) => ({
        id: s.id,
        image: s.image || s.foto || '',
        title: s.title || '',
        subtitle: s.subtitle || ''
      })).filter((s) => s.image)
    };
    setSavingCarousel(true);
    try {
      await saveCarouselInicialApi(toSave);
      toast.success('Carrossel inicial salvo no servidor! A página principal carregará as fotos do banco.');
    } catch (err) {
      const msg = err.response?.data?.error || err.message || 'Erro ao salvar carrossel';
      toast.error(msg);
    } finally {
      setSavingCarousel(false);
    }
  };

  const addSlideCarouselInicial = () => {
    const newSlide = {
      id: Date.now(),
      image: '',
      title: '',
      subtitle: ''
    };
    setCarouselInicial((prev) => ({ ...prev, slides: [...prev.slides, newSlide] }));
  };

  const updateSlideCarouselInicial = (index, field, value) => {
    setCarouselInicial((prev) => {
      const slides = [...prev.slides];
      if (!slides[index]) return prev;
      slides[index] = { ...slides[index], [field]: value };
      return { ...prev, slides };
    });
  };

  const removeSlideCarouselInicial = (index) => {
    setCarouselInicial((prev) => ({
      ...prev,
      slides: prev.slides.filter((_, i) => i !== index)
    }));
  };

  const moveSlideCarouselInicial = (index, direction) => {
    const slides = [...carouselInicial.slides];
    const to = direction === 'up' ? index - 1 : index + 1;
    if (to < 0 || to >= slides.length) return;
    [slides[index], slides[to]] = [slides[to], slides[index]];
    setCarouselInicial((prev) => ({ ...prev, slides }));
  };

  const openCropModal = (slideIndex) => {
    setUploadFullForSlideIndex(null);
    setCropModalSlideIndex(slideIndex);
    carouselFileInputRef.current?.click();
  };

  const openUploadFull = (slideIndex) => {
    setCropModalSlideIndex(null);
    setUploadFullForSlideIndex(slideIndex);
    carouselUploadFullRef.current?.click();
  };

  const onCarouselFileChange = (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file || !file.type.startsWith('image/')) {
      toast.error('Selecione uma imagem (JPEG, PNG, GIF ou WebP).');
      return;
    }
    setCropModalSrc(URL.createObjectURL(file));
    setCropModalOpen(true);
  };

  const onCarouselUploadFullChange = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    const slideIndex = uploadFullForSlideIndex;
    setUploadFullForSlideIndex(null);
    if (!file || !file.type.startsWith('image/')) {
      toast.error('Selecione uma imagem (JPEG, PNG, GIF ou WebP).');
      return;
    }
    if (slideIndex == null) return;
    setUploadingCarouselImage(true);
    try {
      const res = await uploadCarouselImage(file);
      const url = (res.data && (res.data.url ?? res.data)) || null;
      if (url && typeof url === 'string') {
        updateSlideCarouselInicial(slideIndex, 'image', url);
        toast.success('Imagem enviada. Use ' + CAROUSEL_DIMENSOES + ' px para o tamanho correto.');
      } else {
        toast.error('Resposta inválida do servidor.');
      }
    } catch (err) {
      console.error('Erro no upload do carrossel:', err);
      const status = err.response?.status;
      if (status === 404) {
        toast.error('Rota de upload não encontrada (404). Configure o Apache para repassar /api ao backend.');
      } else {
        toast.error(err.response?.data?.error || err.message || 'Erro ao enviar imagem.');
      }
    } finally {
      setUploadingCarouselImage(false);
    }
  };

  const onCropConfirm = async (blob) => {
    if (cropModalSlideIndex == null || !blob) {
      if (cropModalSrc) URL.revokeObjectURL(cropModalSrc);
      setCropModalOpen(false);
      setCropModalSrc(null);
      setCropModalSlideIndex(null);
      return;
    }
    setUploadingCarouselImage(true);
    try {
      const res = await uploadCarouselImage(blob);
      const url = (res.data && (res.data.url ?? res.data)) || null;
      if (url && typeof url === 'string') {
        updateSlideCarouselInicial(cropModalSlideIndex, 'image', url);
        toast.success('Imagem enviada e salva. Atualize a página inicial para ver no carrossel.');
      } else {
        console.error('Resposta do upload:', res.data);
        toast.error('Resposta inválida do servidor.');
      }
    } catch (err) {
      console.error('Erro no upload do carrossel:', err);
      const status = err.response?.status;
      const url = err.config?.url != null ? (err.config.baseURL || '') + (err.config.url || '') : '';
      if (status === 404) {
        const hint = 'Configure o Apache para repassar /api ao backend (veja apache-proxy-api.conf no projeto).';
        toast.error(`Rota de upload não encontrada (404). ${hint} URL: ${url || '/api/...'}`);
      } else {
        toast.error(err.response?.data?.error || err.message || 'Erro ao enviar imagem.');
      }
    } finally {
      setUploadingCarouselImage(false);
      if (cropModalSrc) URL.revokeObjectURL(cropModalSrc);
      setCropModalOpen(false);
      setCropModalSrc(null);
      setCropModalSlideIndex(null);
    }
  };

  const onCropCancel = () => {
    if (cropModalSrc) URL.revokeObjectURL(cropModalSrc);
    setCropModalOpen(false);
    setCropModalSrc(null);
    setCropModalSlideIndex(null);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('cliente');
    navigate('/');
    window.location.reload();
  };

  const loadSubcategorias = async () => {
    try {
      const res = await getSubcategorias();
      setSubcategorias(Array.isArray(res.data) ? res.data : []);
    } catch {
      setSubcategorias([]);
    }
  };

  const loadSubcategoriasForCategoria = async (categoriaId) => {
    if (!categoriaId) {
      setSubcategoriasPorCategoria([]);
      return;
    }
    try {
      const res = await getSubcategoriasByCategoria(categoriaId);
      setSubcategoriasPorCategoria(Array.isArray(res.data) ? res.data : []);
    } catch {
      setSubcategoriasPorCategoria([]);
    }
  };

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    const next = { ...formData, [name]: value };
    if (name === 'categoria_id') {
      next.subcategoria_id = '';
      loadSubcategoriasForCategoria(value);
    }
    setFormData(next);
  };

  // Para subcategoria "coloração": limite de fotos maior e exibir quadradinhos de cores
  const selectedSubcategoriaId = editingProduto?.subcategoria_id ?? formData.subcategoria_id;
  const selectedSub = subcategoriasPorCategoria.find(s => String(s.id) === String(selectedSubcategoriaId));
  const isColoration = isColoracaoNome(selectedSub?.nome);
  const MAX_FOTOS_PADRAO = 5;
  const MAX_FOTOS_COLORACAO = 50;
  const maxFotosProduto = isColoration ? MAX_FOTOS_COLORACAO : MAX_FOTOS_PADRAO;

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const totalFotos = fotos.length + (editingProduto ? fotosExistentes.length : 0) + files.length;
    
    if (totalFotos > maxFotosProduto) {
      toast.warning(`Máximo de ${maxFotosProduto} fotos por produto. Você tem ${fotos.length + (editingProduto ? fotosExistentes.length : 0)} e está adicionando ${files.length}.`);
      e.target.value = '';
      return;
    }
    
    if (files.length > maxFotosProduto) {
      toast.warning(`Selecione no máximo ${maxFotosProduto} imagens de uma vez.`);
      e.target.value = '';
      return;
    }
    
    setFotos(files);
  };

  const removeFoto = (index) => {
    const novasFotos = fotos.filter((_, i) => i !== index);
    setFotos(novasFotos);
  };

  const removeFotoExistente = (fotoUrl) => {
    setFotosExistentes(fotosExistentes.filter(f => f !== fotoUrl));
  };

  const moveFoto = (index, direction) => {
    const novasFotos = [...fotos];
    if (direction === 'up' && index > 0) {
      [novasFotos[index - 1], novasFotos[index]] = [novasFotos[index], novasFotos[index - 1]];
      setFotos(novasFotos);
    } else if (direction === 'down' && index < novasFotos.length - 1) {
      [novasFotos[index], novasFotos[index + 1]] = [novasFotos[index + 1], novasFotos[index]];
      setFotos(novasFotos);
    }
  };

  const moveFotoExistente = (index, direction) => {
    const novasFotos = [...fotosExistentes];
    if (direction === 'up' && index > 0) {
      [novasFotos[index - 1], novasFotos[index]] = [novasFotos[index], novasFotos[index - 1]];
      setFotosExistentes(novasFotos);
    } else if (direction === 'down' && index < novasFotos.length - 1) {
      [novasFotos[index], novasFotos[index + 1]] = [novasFotos[index + 1], novasFotos[index]];
      setFotosExistentes(novasFotos);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const data = new FormData();
      data.append('nome', formData.nome);
      data.append('descricao', formData.descricao);
      data.append('preco', formData.preco);
      if (formData.preco_anterior) {
        data.append('preco_anterior', formData.preco_anterior);
      }
      if (formData.categoria_id) {
        data.append('categoria_id', formData.categoria_id);
      }
      if (formData.subcategoria_id) {
        data.append('subcategoria_id', formData.subcategoria_id);
      }
      if (formData.quantidade !== undefined && formData.quantidade !== '') {
        data.append('quantidade', formData.quantidade);
      }
      
      // Adicionar múltiplas fotos com ordem
      fotos.forEach((foto, index) => {
        data.append('fotos', foto);
      });
      
      // Adicionar ordem das fotos (existentes mantidas + novas)
      let todasFotos = [];
      if (editingProduto && fotosExistentes.length > 0) {
        // Ao editar: manter ordem das existentes e adicionar novas no final
        todasFotos = [...fotosExistentes, ...fotos.map((_, i) => `new_${i}`)];
      } else {
        // Ao criar: apenas novas fotos
        todasFotos = fotos.map((_, i) => `new_${i}`);
      }
      data.append('ordem_fotos', JSON.stringify(todasFotos));
      
      // Se há fotos existentes para remover
      if (editingProduto && fotosExistentes.length < (editingProduto.fotos?.length || 0)) {
        const fotosRemovidas = (editingProduto.fotos || []).filter(f => !fotosExistentes.includes(f));
        if (fotosRemovidas.length > 0) {
          data.append('remover_fotos', JSON.stringify(fotosRemovidas));
        }
      }

      if (editingProduto) {
        // Atualizar produto existente
        await updateProduto(editingProduto.id, data);
        toast.success('Produto atualizado com sucesso!');
      } else {
        // Criar novo produto
        const created = await createProduto(data);
        const novoProdutoId = Number(created?.data?.id || 0);
        if (isColoration && coresPendentes.length > 0 && novoProdutoId > 0) {
          for (const cor of coresPendentes) {
            const corData = new FormData();
            corData.append('descricao_cor', cor.descricao_cor);
            corData.append('foto', cor.foto, cor.foto?.name || 'cor.jpg');
            await addProdutoCor(novoProdutoId, corData);
          }
        }
        toast.success('Produto cadastrado com sucesso!');
      }
      
      // Limpar formulário
      setFormData({
        nome: '',
        descricao: '',
        preco: '',
        preco_anterior: '',
        categoria_id: '',
        quantidade: ''
      });
      setFotos([]);
      setFotosExistentes([]);
      setEditingProduto(null);
      setProdutoCores([]);
      setCoresPendentes([]);
      
      // Recarregar lista de produtos
      if (activeTab === 'produtos' || activeTab === 'cadastro') {
        loadProdutos();
      }
    } catch (error) {
      console.error('Erro ao salvar produto:', error);
      const errorMsg = error.response?.data?.error || 'Erro ao salvar produto. Verifique se está logado como administrador.';
      toast.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = async (produtoId) => {
    try {
      setLoading(true);
      const response = await getProduto(produtoId);
      const produto = response.data;
      
      setFormData({
        nome: produto.nome || '',
        descricao: produto.descricao || '',
        preco: produto.preco || '',
        preco_anterior: produto.preco_anterior || '',
        categoria_id: produto.categoria_id || '',
        subcategoria_id: produto.subcategoria_id || '',
        quantidade: produto.estoque_quantidade || ''
      });
      loadSubcategoriasForCategoria(produto.categoria_id || '');
      setEditingProduto(produto);
      // Carregar fotos existentes
      const fotosProduto = produto.fotos || (produto.foto ? [produto.foto] : []);
      setFotosExistentes(fotosProduto);
      setFotos([]); // Resetar novas fotos
      
      // Mudar para aba de cadastro
      setActiveTab('cadastro');
      
      // Scroll para o topo do formulário
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (error) {
      console.error('Erro ao carregar produto para edição:', error);
      toast.error('Erro ao carregar dados do produto');
    } finally {
      setLoading(false);
    }
  };

  const handleCancelEdit = () => {
    setEditingProduto(null);
    setProdutoCores([]);
    setCoresPendentes([]);
    setCorForm({ descricao_cor: '', foto: null });
    setFormData({
      nome: '',
      descricao: '',
      preco: '',
      preco_anterior: '',
      categoria_id: '',
      subcategoria_id: '',
      quantidade: ''
    });
    setSubcategoriasPorCategoria([]);
    setFotos([]);
    setFotosExistentes([]);
  };

  // Carregar variações do produto (cor/tamanho/etc)
  useEffect(() => {
    if (!editingProduto?.id) {
      setProdutoCores([]);
      return;
    }
    getProdutoCores(editingProduto.id)
      .then(r => setProdutoCores(r.data || []))
      .catch(() => setProdutoCores([]));
  }, [editingProduto?.id]);

  // Prévia da foto da cor: criar e revogar object URL
  useEffect(() => {
    if (corForm.foto && corForm.foto instanceof File) {
      const url = URL.createObjectURL(corForm.foto);
      setCorPreviewUrl(url);
      return () => URL.revokeObjectURL(url);
    }
    setCorPreviewUrl(null);
    return undefined;
  }, [corForm.foto]);

  useEffect(() => {
    if (!isColoration) {
      setCoresPendentes([]);
      setCorForm({ descricao_cor: '', foto: null });
    }
  }, [isColoration]);

  const handleAddCor = async (e) => {
    e.preventDefault();
    let produtoId = editingProduto?.id != null ? Number(editingProduto.id) : null;
    if (!corForm.descricao_cor.trim()) {
      toast.error('Informe a descrição da variação.');
      return;
    }
    if (!corForm.foto || !(corForm.foto instanceof File)) {
      toast.error('Selecione uma foto para a variação.');
      return;
    }

    setLoadingCor(true);
    try {
      if (!produtoId) {
        if (!formData.nome?.trim() || !formData.preco || !formData.categoria_id || !formData.subcategoria_id) {
          toast.error('Preencha nome, preço, categoria e subcategoria antes de adicionar cor.');
          return;
        }

        const createData = new FormData();
        createData.append('nome', formData.nome);
        createData.append('descricao', formData.descricao || '');
        createData.append('preco', formData.preco);
        if (formData.preco_anterior) createData.append('preco_anterior', formData.preco_anterior);
        createData.append('categoria_id', formData.categoria_id);
        createData.append('subcategoria_id', formData.subcategoria_id);
        if (formData.quantidade !== undefined && formData.quantidade !== '') {
          createData.append('quantidade', formData.quantidade);
        }

        fotos.forEach((foto) => createData.append('fotos', foto));
        createData.append('ordem_fotos', JSON.stringify(fotos.map((_, i) => `new_${i}`)));

        const created = await createProduto(createData);
        produtoId = Number(created?.data?.id || 0);
        if (!produtoId) {
          throw new Error('Não foi possível criar o produto antes de salvar a cor.');
        }

        const response = await getProduto(produtoId);
        const produto = response.data;
        setEditingProduto(produto);
        const fotosProduto = produto.fotos || (produto.foto ? [produto.foto] : []);
        setFotosExistentes(fotosProduto);
        setFotos([]);
        setCoresPendentes([]);
        toast.success('Produto criado. Agora a variação será salva.');
      }

      const data = new FormData();
      data.append('descricao_cor', corForm.descricao_cor.trim());
      data.append('foto', corForm.foto, corForm.foto.name || 'cor.jpg');
      await addProdutoCor(produtoId, data);
      toast.success('Variação adicionada. Você pode adicionar outra abaixo.');
      setCorForm({ descricao_cor: '', foto: null });
      setCorPreviewUrl(null);
      if (corFotoInputRef.current) corFotoInputRef.current.value = '';
      const res = await getProdutoCores(produtoId);
      setProdutoCores(res.data || []);
      setTimeout(() => corDescricaoInputRef.current?.focus(), 100);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Erro ao adicionar variação');
    } finally {
      setLoadingCor(false);
    }
  };

  const handleRemoveCorPendente = (corId) => {
    setCoresPendentes((prev) => prev.filter((c) => c.id !== corId));
  };

  const handleRemoveCor = async (corId) => {
    if (!editingProduto?.id || !window.confirm('Remover esta variação?')) return;
    try {
      await deleteProdutoCor(editingProduto.id, corId);
      toast.success('Variação removida.');
      const res = await getProdutoCores(editingProduto.id);
      setProdutoCores(res.data || []);
    } catch (err) {
      toast.error('Erro ao remover variação');
    }
  };

  const handleMoveCor = async (index, direction) => {
    if (!editingProduto?.id || produtoCores.length < 2) return;
    const to = direction === 'up' ? index - 1 : index + 1;
    if (to < 0 || to >= produtoCores.length) return;
    const novaOrdem = [...produtoCores];
    [novaOrdem[index], novaOrdem[to]] = [novaOrdem[to], novaOrdem[index]];
    const ids = novaOrdem.map(c => c.id);
    try {
      await updateProdutoCoresOrder(editingProduto.id, ids);
      setProdutoCores(novaOrdem);
      toast.success('Ordem atualizada.');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Erro ao ordenar cores');
    }
  };

  const loadProdutos = async () => {
    setLoadingProdutos(true);
    try {
      const response = await getProdutos();
      setProdutos(response.data);
    } catch (error) {
      console.error('Erro ao carregar produtos:', error);
    } finally {
      setLoadingProdutos(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Tem certeza que deseja deletar este produto?')) {
      return;
    }

    try {
      await deleteProduto(id);
      toast.success('Produto deletado com sucesso!');
      loadProdutos();
    } catch (error) {
      console.error('Erro ao deletar produto:', error);
      toast.error('Erro ao deletar produto. Verifique se está logado como administrador.');
    }
  };

  const loadClientes = async () => {
    setLoadingClientes(true);
    try {
      const response = await getClientes();
      setClientes(response.data);
    } catch (error) {
      console.error('Erro ao carregar clientes:', error);
    } finally {
      setLoadingClientes(false);
    }
  };

  const loadCategorias = async () => {
    setLoadingCategorias(true);
    try {
      const response = await getCategorias();
      setCategorias(response.data);
    } catch (error) {
      console.error('Erro ao carregar categorias:', error);
    } finally {
      setLoadingCategorias(false);
    }
  };

  const handleCategoriaSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await createCategoria(categoriaForm);
      toast.success('Categoria criada com sucesso!');
      setCategoriaForm({ nome: '', descricao: '', icone: '' });
      loadCategorias();
    } catch (error) {
      console.error('Erro ao criar categoria:', error);
      toast.error(error.response?.data?.error || 'Erro ao criar categoria');
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteCategoria = async (id) => {
    if (!window.confirm('Tem certeza que deseja deletar esta categoria?')) {
      return;
    }
    try {
      await deleteCategoria(id);
      toast.success('Categoria deletada com sucesso!');
      loadCategorias();
      loadSubcategorias();
    } catch (error) {
      console.error('Erro ao deletar categoria:', error);
      toast.error('Erro ao deletar categoria');
    }
  };

  const handleSubcategoriaSubmit = async (e) => {
    e.preventDefault();
    const catId = subcategoriaForm.categoria_id;
    const nome = subcategoriaForm.nome.trim();
    if (!catId || !nome) {
      toast.error('Selecione a categoria e informe o nome da subcategoria.');
      return;
    }
    setLoading(true);
    try {
      await createSubcategoria({ categoria_id: parseInt(catId, 10), nome });
      toast.success('Subcategoria criada com sucesso!');
      setSubcategoriaForm({ categoria_id: '', nome: '' });
      loadSubcategorias();
    } catch (err) {
      const msg = err.response?.data?.error || err.message || 'Erro ao criar subcategoria';
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  const handleAddSubcategoriaForCategoria = async (categoriaId, nomeInput) => {
    const nome = nomeInput?.value?.trim();
    if (!nome) {
      toast.error('Informe o nome da subcategoria.');
      return;
    }
    setLoading(true);
    try {
      await createSubcategoria({ categoria_id: parseInt(categoriaId, 10), nome });
      toast.success('Subcategoria criada com sucesso!');
      if (nomeInput) nomeInput.value = '';
      loadSubcategorias();
    } catch (err) {
      const msg = err.response?.data?.error || err.message || 'Erro ao criar subcategoria';
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteSubcategoria = async (id) => {
    if (!window.confirm('Remover esta subcategoria? Os produtos continuarão vinculados à categoria.')) return;
    try {
      await deleteSubcategoria(id);
      toast.success('Subcategoria removida.');
      loadSubcategorias();
    } catch (err) {
      toast.error('Erro ao remover subcategoria');
    }
  };

  const loadCarouselProdutos = () => {
    // Carregar produtos do localStorage ou usar os primeiros 5
    const saved = localStorage.getItem('carouselProdutos');
    if (saved) {
      const ids = JSON.parse(saved);
      const selected = produtos.filter(p => ids.includes(p.id));
      setCarouselProdutos(selected.length > 0 ? selected : produtos.slice(0, 5));
    } else {
      setCarouselProdutos(produtos.slice(0, 5));
    }
  };

  const updateCarousel = (produtoIds) => {
    localStorage.setItem('carouselProdutos', JSON.stringify(produtoIds));
    const selected = produtos.filter(p => produtoIds.includes(p.id));
    setCarouselProdutos(selected);
    toast.success('Carrossel atualizado com sucesso!');
  };

  const loadEstoque = async () => {
    setLoadingEstoque(true);
    try {
      const res = await getEstoque();
      setEstoqueProdutos(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      setEstoqueProdutos([]);
      toast.error(err.response?.data?.error || 'Erro ao carregar estoque.');
    } finally {
      setLoadingEstoque(false);
    }
  };

  const loadMovimentacoesEstoque = async () => {
    setLoadingMovEstoque(true);
    try {
      const res = await getMovimentacoesEstoque({ limit: 60 });
      setMovimentacoesEstoque(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      setMovimentacoesEstoque([]);
      toast.error(err.response?.data?.error || 'Erro ao carregar movimentações.');
    } finally {
      setLoadingMovEstoque(false);
    }
  };

  const handleEstoqueFieldChange = (produtoId, field, value) => {
    setEstoqueProdutos((prev) => prev.map((item) => (
      Number(item.produto_id) === Number(produtoId)
        ? { ...item, [field]: value }
        : item
    )));
  };

  const handleSalvarEstoqueProduto = async (produtoId) => {
    const item = estoqueProdutos.find((p) => Number(p.produto_id) === Number(produtoId));
    if (!item) return;
    const quantidade = Math.max(0, parseInt(item.quantidade, 10) || 0);
    const quantidade_minima = Math.max(0, parseInt(item.quantidade_minima, 10) || 0);
    const preco_venda = Math.max(0, parseFloat(String(item.preco_venda || 0).replace(',', '.')) || 0);
    const preco_compra_raw = String(item.preco_compra ?? '').trim();
    const preco_compra = preco_compra_raw === '' ? null : (Math.max(0, parseFloat(preco_compra_raw.replace(',', '.')) || 0));
    setSavingEstoqueProdutoId(produtoId);
    try {
      await updateEstoque(produtoId, { quantidade, quantidade_minima, preco_venda, preco_compra });
      toast.success('Estoque atualizado.');
      setEstoqueProdutos((prev) => prev.map((p) => (
        Number(p.produto_id) === Number(produtoId)
          ? { ...p, quantidade, quantidade_minima, preco_venda, preco_compra }
          : p
      )));
    } catch (err) {
      toast.error(err.response?.data?.error || 'Erro ao salvar estoque.');
    } finally {
      setSavingEstoqueProdutoId(null);
    }
  };

  const toggleSelecionadoEstoque = (produtoId) => {
    setEstoqueSelecionados((prev) => ({ ...prev, [produtoId]: !prev[produtoId] }));
  };

  const handleSalvarLoteEstoque = async () => {
    const selecionados = estoqueProdutos.filter((item) => estoqueSelecionados[item.produto_id]);
    if (selecionados.length === 0) {
      toast.error('Selecione ao menos um produto para ajuste em lote.');
      return;
    }
    const ajustes = selecionados.map((item) => ({
      produto_id: item.produto_id,
      quantidade: Math.max(0, parseInt(item.quantidade, 10) || 0),
      quantidade_minima: Math.max(0, parseInt(item.quantidade_minima, 10) || 0),
      preco_venda: Math.max(0, parseFloat(String(item.preco_venda || 0).replace(',', '.')) || 0),
      preco_compra: String(item.preco_compra ?? '').trim() === '' ? null : (Math.max(0, parseFloat(String(item.preco_compra).replace(',', '.')) || 0)),
      motivo: motivoLote || 'Ajuste em lote'
    }));
    setSavingLote(true);
    try {
      await ajustarEstoqueLote(ajustes);
      toast.success('Ajuste em lote concluído.');
      setEstoqueSelecionados({});
      setMotivoLote('');
      loadEstoque();
      loadMovimentacoesEstoque();
    } catch (err) {
      toast.error(err.response?.data?.error || 'Erro no ajuste em lote.');
    } finally {
      setSavingLote(false);
    }
  };

  useEffect(() => {
    loadCategorias();
    if (activeTab === 'categorias') {
      loadSubcategorias();
    }
    if (activeTab === 'produtos' || activeTab === 'cadastro' || activeTab === 'carousel') {
      loadProdutos();
    }
    if (activeTab === 'estoque') {
      loadEstoque();
      loadMovimentacoesEstoque();
    }
    if (activeTab === 'carouselInicial') {
      loadCarouselInicial();
      checkApiHealth().then(setApiReachable);
    }
    if (activeTab === 'clientes') {
      loadClientes();
    }
    if (activeTab === 'dashboard') {
      loadProdutos();
      loadClientes();
    }
    if (activeTab === 'vendas') {
      loadPrazoConfig();
      loadPedidos();
      loadVendasStats();
    }
    if (activeTab === 'graficos') {
      loadVendasStats();
    }
    if (activeTab === 'relatorioImpresso') {
      loadVendasStats();
    }
    if (activeTab === 'graficosAprazo') {
      loadAprazoStats();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- run only when activeTab changes
  }, [activeTab]);

  useEffect(() => {
    if (activeTab === 'vendas' && vendaStep === 'cliente') loadClientes();
  }, [activeTab, vendaStep]);

  useEffect(() => {
    if ((activeTab === 'vendas' || activeTab === 'graficos' || activeTab === 'relatorioImpresso') && vendaStep === null) {
      loadVendasStats();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- recarregar gráfico no filtro
  }, [periodoGrafico]);

  useEffect(() => {
    if (activeTab === 'graficosAprazo' && vendaStep === null) {
      loadAprazoStats();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [periodoGraficoAprazo]);

  useEffect(() => {
    if (activeTab === 'vendas' && vendaStep === 'carrinho') {
      setLoadingProdutosVenda(true);
      getProdutos()
        .then((res) => setProdutosVenda(Array.isArray(res.data) ? res.data : []))
        .catch(() => setProdutosVenda([]))
        .finally(() => setLoadingProdutosVenda(false));
      getCategorias()
        .then((res) => setCategoriasVenda(Array.isArray(res.data) ? res.data : []))
        .catch(() => setCategoriasVenda([]));
    }
  }, [activeTab, vendaStep]);

  const parseDecimalBr = (val) => {
    if (val === null || val === undefined) return 0;
    const s = String(val).trim().replace(',', '.');
    return parseFloat(s) || 0;
  };

  const loadPrazoConfig = async () => {
    try {
      const res = await getPrazoConfig();
      const d = res.data || {};
      const max = Math.min(24, Math.max(1, parseInt(d.maxParcelas, 10) || 3));
      const juros = d.juros && typeof d.juros === 'object' ? d.juros : {};
      const jurosStr = {};
      for (let n = 1; n <= max; n++) {
        const raw = juros[String(n)] ?? juros[n];
        const num = typeof raw === 'number' ? raw : parseDecimalBr(raw);
        jurosStr[String(n)] = Number.isFinite(num) ? String(Number(num.toFixed(4))) : '0';
      }
      setPrazoConfig({ maxParcelas: max, juros: jurosStr });
    } catch {
      setPrazoConfig({ maxParcelas: 3, juros: { '1': '0', '2': '5', '3': '10' } });
    }
  };

  const loadPedidos = async ({ silent = false } = {}) => {
    if (!silent) setLoadingPedidos(true);
    try {
      const res = await getPedidosAdmin();
      const lista = Array.isArray(res.data) ? res.data : [];
      setPedidos(lista);
      setPedidoSelecionado((prev) => {
        if (!prev) return activeTab === 'vendas' ? (lista[0] || null) : null;
        return lista.find((pedido) => pedido.id === prev.id) || (activeTab === 'vendas' ? (lista[0] || null) : null);
      });
      if (activeTab === 'vendas') {
        marcarComprasComoVistas(lista);
      } else {
        const count = lista.filter((pedido) => isCompraCliente(pedido) && Number(pedido.id) > ultimoPedidoVistoId).length;
        setNovasCompras(count);
      }
    } catch {
      setPedidos([]);
      if (activeTab !== 'vendas') setNovasCompras(0);
    } finally {
      if (!silent) setLoadingPedidos(false);
    }
  };

  const loadVendasStats = async ({ silent = false } = {}) => {
    if (!silent) setLoadingStatsVendas(true);
    try {
      const res = await getPedidosAdminStats({ periodo: periodoGrafico, limit: 5 });
      const data = res.data || {};
      setStatsVendas({
        totalVendas: parseMoney(data.totalVendas),
        totalPedidos: Math.max(0, parseInt(data.totalPedidos, 10) || 0),
        ticketMedio: parseMoney(data.ticketMedio),
        serie: Array.isArray(data.serie)
          ? data.serie.map((p) => ({
              label: p.label != null ? String(p.label) : '—',
              total: parseMoney(p.total)
            }))
          : [],
        topProdutos: Array.isArray(data.topProdutos)
          ? data.topProdutos.map((p) => ({
              nome_produto: p.nome_produto != null ? String(p.nome_produto) : 'Sem nome',
              quantidade: Math.max(0, parseInt(p.quantidade, 10) || 0),
              total: parseMoney(p.total)
            }))
          : [],
        topClientes: Array.isArray(data.topClientes)
          ? data.topClientes.map((c) => ({
              id: c.id,
              nome: c.nome != null ? String(c.nome) : '',
              email: c.email != null ? String(c.email) : '',
              pedidos: Math.max(0, parseInt(c.pedidos, 10) || 0),
              total: parseMoney(c.total)
            }))
          : []
      });
    } catch {
      setStatsVendas({
        totalVendas: 0,
        totalPedidos: 0,
        ticketMedio: 0,
        serie: [],
        topProdutos: [],
        topClientes: []
      });
    } finally {
      if (!silent) setLoadingStatsVendas(false);
    }
  };

  const loadAprazoStats = async ({ silent = false } = {}) => {
    if (!silent) setLoadingStatsAprazo(true);
    try {
      const res = await getPrazoAdminStats({ periodo: periodoGraficoAprazo, limit: 5 });
      const data = res.data || {};
      setStatsAprazo({
        totalPagamentosRecebidos: parseMoney(data.totalPagamentosRecebidos),
        totalNovasVendasValor: parseMoney(data.totalNovasVendasValor),
        vendasRegistradasNoPeriodo: Math.max(0, parseInt(data.vendasRegistradasNoPeriodo, 10) || 0),
        saldoEmAberto: parseMoney(data.saldoEmAberto),
        vendasAbertasCount: Math.max(0, parseInt(data.vendasAbertasCount, 10) || 0),
        seriePagamentos: Array.isArray(data.seriePagamentos)
          ? data.seriePagamentos.map((p) => ({
              label: p.label != null ? String(p.label) : '—',
              total: parseMoney(p.total)
            }))
          : [],
        serieNovasVendas: Array.isArray(data.serieNovasVendas)
          ? data.serieNovasVendas.map((p) => ({
              label: p.label != null ? String(p.label) : '—',
              total: parseMoney(p.total)
            }))
          : [],
        porMetodoPagamento: Array.isArray(data.porMetodoPagamento)
          ? data.porMetodoPagamento.map((m) => ({
              metodo: m.metodo != null ? String(m.metodo) : '—',
              total: parseMoney(m.total)
            }))
          : [],
        topClientesRecebimentos: Array.isArray(data.topClientesRecebimentos)
          ? data.topClientesRecebimentos.map((c) => ({
              nome: c.nome != null ? String(c.nome) : '—',
              total: parseMoney(c.total)
            }))
          : [],
        topProdutos: Array.isArray(data.topProdutos)
          ? data.topProdutos.map((p) => ({
              nome_produto: p.nome_produto != null ? String(p.nome_produto) : 'Sem nome',
              quantidade: Math.max(0, parseInt(p.quantidade, 10) || 0),
              total: parseMoney(p.total)
            }))
          : []
      });
    } catch {
      setStatsAprazo({
        totalPagamentosRecebidos: 0,
        totalNovasVendasValor: 0,
        vendasRegistradasNoPeriodo: 0,
        saldoEmAberto: 0,
        vendasAbertasCount: 0,
        seriePagamentos: [],
        serieNovasVendas: [],
        porMetodoPagamento: [],
        topClientesRecebimentos: [],
        topProdutos: []
      });
    } finally {
      if (!silent) setLoadingStatsAprazo(false);
    }
  };

  const togglePainelVendasAprazoPeriodo = () => {
    if (!painelPeriodoVendasAprazoAberto && !periodoVendasAprazoIni && !periodoVendasAprazoFim) {
      const agora = new Date();
      const y = agora.getFullYear();
      const m = agora.getMonth();
      const pad = (n) => String(n).padStart(2, '0');
      const ultimoDia = new Date(y, m + 1, 0).getDate();
      setPeriodoVendasAprazoIni(`${y}-${pad(m + 1)}-01`);
      setPeriodoVendasAprazoFim(`${y}-${pad(m + 1)}-${pad(ultimoDia)}`);
    }
    setPainelPeriodoVendasAprazoAberto((o) => !o);
  };

  const buscarVendasAprazoPorPeriodo = async () => {
    if (!periodoVendasAprazoIni || !periodoVendasAprazoFim) {
      toast.error('Informe a data inicial e a data final.');
      return;
    }
    if (periodoVendasAprazoIni > periodoVendasAprazoFim) {
      toast.error('A data inicial não pode ser maior que a data final.');
      return;
    }
    setLoadingVendasAprazoPeriodo(true);
    const iniReq = periodoVendasAprazoIni;
    const fimReq = periodoVendasAprazoFim;
    try {
      const res = await getPrazoVendasAdmin({
        data_inicio: iniReq,
        data_fim: fimReq,
        sem_itens: '1'
      });
      if (
        periodoVendasAprazoRef.current.ini !== iniReq ||
        periodoVendasAprazoRef.current.fim !== fimReq
      ) {
        return;
      }
      const lista = Array.isArray(res.data) ? res.data : [];
      const listaNoPeriodo = filtrarVendasAprazoNoPeriodo(lista, iniReq, fimReq);
      setVendasAprazoListaPeriodo(listaNoPeriodo);
      setVendasAprazoPeriodoConsultado(true);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Erro ao buscar vendas no período.');
      setVendasAprazoListaPeriodo([]);
    } finally {
      setLoadingVendasAprazoPeriodo(false);
    }
  };

  useEffect(() => {
    periodoVendasAprazoRef.current = { ini: periodoVendasAprazoIni, fim: periodoVendasAprazoFim };
    setVendasAprazoListaPeriodo([]);
    setVendasAprazoPeriodoConsultado(false);
  }, [periodoVendasAprazoIni, periodoVendasAprazoFim]);

  useEffect(() => {
    loadPedidos({ silent: true });
    const timer = setInterval(() => loadPedidos({ silent: true }), 60000);
    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- fallback de sincronização
  }, [activeTab, ultimoPedidoVistoId]);

  useEffect(() => {
    if (!token) return undefined;
    const isProduction = process.env.NODE_ENV === 'production';
    const apiBase = isProduction
      ? (process.env.REACT_APP_API_URL || '/api')
      : (process.env.REACT_APP_API_URL || 'http://localhost:3005/api');
    const streamUrl = `${apiBase}/pedidos/admin/stream?token=${encodeURIComponent(token)}`;
    const source = new EventSource(streamUrl);
    source.addEventListener('pedidos', () => {
      loadPedidos({ silent: true });
      if (activeTab === 'vendas') loadVendasStats({ silent: true });
    });
    source.onerror = () => {
      // EventSource tenta reconectar automaticamente; sem toast para não poluir.
    };
    return () => source.close();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- conexão SSE única por token
  }, [token, activeTab]);

  const abrirTelaVendas = () => {
    setVendaStep(null);
    setActiveTab('vendas');
    marcarComprasComoVistas(pedidos);
  };

  const abrirRelatorioImpresso = () => {
    setVendaStep(null);
    setActiveTab('relatorioImpresso');
  };

  const abrirGraficosAprazo = () => {
    setVendaStep(null);
    setActiveTab('graficosAprazo');
  };

  const handleSalvarPrazoConfig = async (e) => {
    e.preventDefault();
    const max = Math.min(24, Math.max(1, parseInt(prazoConfig.maxParcelas, 10) || 3));
    const juros = {};
    for (let n = 1; n <= max; n++) {
      const v = parseDecimalBr(prazoConfig.juros[String(n)]);
      if (v < 0 || v > 100) {
        toast.error(`Juros para ${n}x deve ser entre 0 e 100.`);
        return;
      }
      juros[String(n)] = v;
    }
    try {
      const payload = { maxParcelas: max, juros: { ...juros } };
      await updatePrazoConfig(payload);
      await loadPrazoConfig();
      toast.success('Configuração de prazo salva.');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Erro ao salvar.');
    }
  };

  const setPrazoMaxParcelas = (v) => {
    const num = Math.min(24, Math.max(1, parseInt(v, 10) || 1));
    setPrazoConfig(prev => {
      const nextJuros = { ...prev.juros };
      for (let n = 1; n <= num; n++) if (nextJuros[String(n)] === undefined) nextJuros[String(n)] = '0';
      for (let n = num + 1; n <= 24; n++) delete nextJuros[String(n)];
      return { maxParcelas: num, juros: nextJuros };
    });
  };

  const setPrazoJuros = (parcelas, valor) => {
    setPrazoConfig(prev => ({ ...prev, juros: { ...prev.juros, [String(parcelas)]: valor } }));
  };

  const handleAprovarPedido = async (pedidoId, status) => {
    try {
      await updatePedidoStatus(pedidoId, status);
      toast.success(status === 'confirmado' ? 'Pedido aprovado.' : 'Pedido atualizado.');
      loadPedidos();
    } catch (err) {
      toast.error(err.response?.data?.error || 'Erro ao atualizar pedido.');
    }
  };

  const iniciarNovaVenda = () => {
    setVendaStep('cliente');
    setClienteVenda(null);
    setCarrinhoVenda([]);
    setPagamentoTipo('normal');
    setFormaNormal('pix');
    setPrazoEntrada(0);
    setPrazoFormaEntrada('pix');
    setPrazoParcelas(1);
    setPrazoDataPrimeira('');
    setBuscaClienteVenda('');
    setFiltroCategoriaVenda('');
    setFiltroBuscaVenda('');
    setQtyParaAdicionarVenda({});
  };

  const cancelarNovaVenda = () => {
    setVendaStep(null);
    setClienteVenda(null);
    setCarrinhoVenda([]);
  };

  const adicionarAoCarrinhoVenda = (produto, quantidade = 1) => {
    const qty = Math.max(1, parseInt(quantidade, 10) || 1);
    const preco = parseFloat(produto.preco) || 0;
    setCarrinhoVenda(prev => {
      const idx = prev.findIndex(i => (i.produto?.id || i.produto?.id) === (produto.id || produto.id));
      if (idx >= 0) {
        const next = [...prev];
        next[idx].quantidade += qty;
        return next;
      }
      return [...prev, { produto: { ...produto, preco }, quantidade: qty }];
    });
  };

  const removerDoCarrinhoVenda = (index) => {
    setCarrinhoVenda(prev => prev.filter((_, i) => i !== index));
  };

  const alterarQtdCarrinhoVenda = (index, novaQtd) => {
    const n = Math.max(0, parseInt(novaQtd, 10) || 0);
    if (n === 0) {
      removerDoCarrinhoVenda(index);
      return;
    }
    setCarrinhoVenda(prev => prev.map((item, i) => i === index ? { ...item, quantidade: n } : item));
  };

  const setQtyAdicionarVenda = (produtoId, value) => {
    setQtyParaAdicionarVenda(prev => ({ ...prev, [String(produtoId)]: value }));
  };

  const totalCarrinhoVenda = carrinhoVenda.reduce((s, i) => s + (parseFloat(i.produto?.preco) || 0) * (i.quantidade || 0), 0);

  const clientesFiltradosVenda = clientes.filter(c => {
    if (!buscaClienteVenda.trim()) return true;
    const t = buscaClienteVenda.toLowerCase();
    return (c.nome && c.nome.toLowerCase().includes(t)) || (c.email && c.email.toLowerCase().includes(t));
  });

  const produtosFiltradosVenda = produtosVenda
    .filter(p => {
      if (!p.ativo) return false;
      if (filtroCategoriaVenda && String(p.categoria_id) !== String(filtroCategoriaVenda)) return false;
      if (filtroBuscaVenda.trim()) {
        const t = filtroBuscaVenda.toLowerCase();
        if (!(p.nome && p.nome.toLowerCase().includes(t))) return false;
      }
      return true;
    })
    .sort((a, b) =>
      String(a.nome || '').localeCompare(String(b.nome || ''), 'pt-BR', { sensitivity: 'base', numeric: true })
    );

  const finalizarParaPagamento = () => {
    if (carrinhoVenda.length === 0) {
      toast.error('Adicione ao menos um produto ao carrinho.');
      return;
    }
    setVendaStep('pagamento');
    setPagamentoTipo('normal');
    setFormaNormal('pix');
    setPrazoParcelas(1);
    const hoje = new Date();
    setPrazoDataPrimeira(hoje.toISOString().slice(0, 10));
  };

  const confirmarVenda = async () => {
    if (pagamentoTipo === 'prazo' && !prazoDataPrimeira) {
      toast.error('Informe a data da primeira parcela.');
      return;
    }
    setLoadingVenda(true);
    try {
      const total = Math.round(totalCarrinhoVenda * 100) / 100;
      const itens = carrinhoVenda.map(({ produto, quantidade }) => ({
        produto_id: produto.id,
        quantidade,
        preco_unitario: parseFloat(produto.preco),
        nome_produto: produto.nome,
        nome: produto.nome,
        preco: produto.preco,
      }));
      const payload = {
        cliente_id: clienteVenda.id,
        itens,
        total,
        forma_pagamento: pagamentoTipo === 'normal' ? formaNormal : 'prazo',
      };
      if (pagamentoTipo === 'prazo') {
        payload.valor_entrada = Math.max(0, parseFloat(prazoEntrada) || 0);
        payload.forma_entrada = payload.valor_entrada > 0 ? prazoFormaEntrada : null;
        payload.parcelas = Math.min(prazoConfig.maxParcelas, Math.max(1, parseInt(prazoParcelas, 10) || 1));
        payload.data_primeira_parcela = prazoDataPrimeira;
      }
      await createPedidoAdmin(payload);
      toast.success('Venda registrada com sucesso.');
      cancelarNovaVenda();
      loadPedidos();
    } catch (err) {
      toast.error(err.response?.data?.error || 'Erro ao registrar venda.');
    } finally {
      setLoadingVenda(false);
    }
  };

  const formatCurrencyBRL = (value) => `R$ ${parseMoney(value).toFixed(2)}`;

  const gerarPdfVendasAprazoPeriodo = async () => {
    if (!periodoVendasAprazoIni || !periodoVendasAprazoFim) {
      toast.error('Informe a data inicial e a data final.');
      return;
    }
    if (periodoVendasAprazoIni > periodoVendasAprazoFim) {
      toast.error('A data inicial não pode ser maior que a data final.');
      return;
    }
    setLoadingPdfAprazoPeriodo(true);
    const iniReq = periodoVendasAprazoIni;
    const fimReq = periodoVendasAprazoFim;
    try {
      const res = await getPrazoVendasAdmin({
        data_inicio: iniReq,
        data_fim: fimReq,
        sem_itens: '1'
      });
      if (
        periodoVendasAprazoRef.current.ini !== iniReq ||
        periodoVendasAprazoRef.current.fim !== fimReq
      ) {
        return;
      }
      const lista = Array.isArray(res.data) ? res.data : [];
      const listaNoPeriodo = filtrarVendasAprazoNoPeriodo(lista, iniReq, fimReq);
      if (listaNoPeriodo.length === 0) {
        toast.info('Nenhuma venda a prazo neste período para gerar o PDF.');
        return;
      }
      const totalPeriodo = listaNoPeriodo.reduce((acc, v) => acc + parseMoney(v.total), 0);
      const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
      const titulo = 'Vendas a prazo (loja) - por periodo';
      const periodoTxt = `Periodo: ${iniReq} a ${fimReq}`;
      const gerado = `Gerado em: ${new Date().toLocaleString('pt-BR')}`;

      doc.setFontSize(14);
      doc.text(titulo, 14, 16);
      doc.setFontSize(10);
      doc.text(periodoTxt, 14, 23);
      doc.text(gerado, 14, 29);

      const body = listaNoPeriodo.map((v) => {
        const dataStr = v.created_at
          ? new Date(v.created_at).toLocaleString('pt-BR', {
              dateStyle: 'short',
              timeStyle: 'short'
            })
          : '—';
        return [
          String(v.id),
          dataStr,
          formatCurrencyBRL(v.total),
          formatCurrencyBRL(v.pago_total),
          formatCurrencyBRL(v.saldo)
        ];
      });

      autoTable(doc, {
        startY: 34,
        head: [['#', 'Data', 'Total', 'Pago', 'Saldo']],
        body,
        styles: { fontSize: 9, cellPadding: 2 },
        headStyles: { fillColor: [46, 125, 50], textColor: 255, fontStyle: 'bold' }
      });

      const finalY = doc.lastAutoTable?.finalY ?? 34;
      doc.setFontSize(11);
      doc.setFont('helvetica', 'bold');
      const linhaTotal = `Total vendido no periodo: ${formatCurrencyBRL(totalPeriodo)} (${listaNoPeriodo.length} ${listaNoPeriodo.length === 1 ? 'venda' : 'vendas'})`;
      const linhasTotal = doc.splitTextToSize(linhaTotal, 180);
      doc.text(linhasTotal, 14, finalY + 10);

      const nomeArquivo = `vendas-aprazo-loja_${iniReq}_${fimReq}.pdf`;
      doc.save(nomeArquivo);
      toast.success('PDF baixado. Você pode anexá-lo ao enviar.');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Erro ao gerar o PDF.');
    } finally {
      setLoadingPdfAprazoPeriodo(false);
    }
  };

  const periodoLabelMap = {
    dia: 'Dia',
    semana: 'Semana',
    mes: 'Mês',
    semestral: 'Semestral',
    anual: 'Anual'
  };

  const escapeHtml = (value) => String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

  const handleImprimirRelatorio = () => {
    const periodoLabel = periodoLabelMap[periodoGrafico] || periodoGrafico;
    const geradoEm = new Date().toLocaleString('pt-BR');

    const linhasPeriodo = statsVendas.serie.length > 0
      ? statsVendas.serie.map((p) => `
          <tr>
            <td>${escapeHtml(p.label)}</td>
            <td>${formatCurrencyBRL(p.total)}</td>
          </tr>
        `).join('')
      : '<tr><td colspan="2">Sem dados no período.</td></tr>';

    const linhasProdutos = statsVendas.topProdutos.length > 0
      ? statsVendas.topProdutos.map((p) => `
          <tr>
            <td>${escapeHtml(p.nome_produto)}</td>
            <td>${Number(p.quantidade || 0)}</td>
            <td>${formatCurrencyBRL(p.total)}</td>
          </tr>
        `).join('')
      : '<tr><td colspan="3">Sem dados no período.</td></tr>';

    const linhasClientes = statsVendas.topClientes.length > 0
      ? statsVendas.topClientes.map((c) => `
          <tr>
            <td>${escapeHtml(c.nome || '-')}</td>
            <td>${escapeHtml(c.email || '-')}</td>
            <td>${Number(c.pedidos || 0)}</td>
            <td>${formatCurrencyBRL(c.total)}</td>
          </tr>
        `).join('')
      : '<tr><td colspan="4">Sem dados no período.</td></tr>';

    const html = `
      <!doctype html>
      <html lang="pt-BR">
      <head>
        <meta charset="utf-8" />
        <title>Relatório de Vendas - Loucas por Beleza</title>
        <style>
          body { font-family: Arial, sans-serif; margin: 24px; color: #222; }
          h1, h2, h3 { margin: 0 0 10px; }
          .meta { margin-bottom: 20px; font-size: 13px; color: #555; }
          .kpis { display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px; margin: 14px 0 20px; }
          .kpi { border: 1px solid #ddd; border-radius: 8px; padding: 10px; }
          .kpi strong { display: block; margin-top: 4px; font-size: 18px; }
          table { width: 100%; border-collapse: collapse; margin-bottom: 18px; }
          th, td { border: 1px solid #ddd; padding: 8px; text-align: left; font-size: 13px; }
          th { background: #f5f7fb; }
          .footer { margin-top: 24px; font-size: 12px; color: #666; }
        </style>
      </head>
      <body>
        <h1>Relatório de Vendas</h1>
        <div class="meta">
          <div><strong>Loja:</strong> Loucas por Beleza</div>
          <div><strong>Período:</strong> ${escapeHtml(periodoLabel)}</div>
          <div><strong>Gerado em:</strong> ${escapeHtml(geradoEm)}</div>
        </div>

        <h2>Resumo</h2>
        <div class="kpis">
          <div class="kpi">Valor total<strong>${formatCurrencyBRL(statsVendas.totalVendas)}</strong></div>
          <div class="kpi">Total de pedidos<strong>${Number(statsVendas.totalPedidos || 0)}</strong></div>
          <div class="kpi">Ticket médio<strong>${formatCurrencyBRL(statsVendas.ticketMedio)}</strong></div>
        </div>

        <h2>Faturamento por período</h2>
        <table>
          <thead><tr><th>Período</th><th>Total vendido</th></tr></thead>
          <tbody>${linhasPeriodo}</tbody>
        </table>

        <h2>Produtos mais vendidos</h2>
        <table>
          <thead><tr><th>Produto</th><th>Quantidade</th><th>Total</th></tr></thead>
          <tbody>${linhasProdutos}</tbody>
        </table>

        <h2>Clientes que mais compraram</h2>
        <table>
          <thead><tr><th>Cliente</th><th>E-mail</th><th>Pedidos</th><th>Total comprado</th></tr></thead>
          <tbody>${linhasClientes}</tbody>
        </table>

        <p class="footer">Relatório gerado pelo painel administrativo.</p>
      </body>
      </html>
    `;

    const printWindow = window.open('', '_blank', 'width=1024,height=768');
    if (!printWindow) {
      toast.error('Não foi possível abrir a janela de impressão.');
      return;
    }
    printWindow.document.open();
    printWindow.document.write(html);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  };

  const chartPeriodoData = {
    labels: statsVendas.serie.map((p) => (p.label != null && String(p.label) !== '' ? String(p.label) : '—')),
    datasets: [
      {
        label: 'Total vendido',
        data: statsVendas.serie.map((p) => parseMoney(p.total)),
        borderColor: '#667eea',
        backgroundColor: 'rgba(102, 126, 234, 0.25)',
        tension: 0.35,
        fill: true
      }
    ]
  };

  const chartProdutosData = {
    labels: statsVendas.topProdutos.map((p) =>
      String(p.nome_produto || 'Sem nome').length > 42
        ? `${String(p.nome_produto || 'Sem nome').slice(0, 40)}…`
        : String(p.nome_produto || 'Sem nome')
    ),
    datasets: [
      {
        label: 'Quantidade vendida',
        data: statsVendas.topProdutos.map((p) => Math.max(0, parseInt(p.quantidade, 10) || 0)),
        backgroundColor: '#7c4dff'
      }
    ]
  };

  const chartClientesData = {
    labels: statsVendas.topClientes.map((c) => {
      const nome = String(c.nome || '').trim();
      const email = String(c.email || '').trim();
      const raw = nome || email || '—';
      return raw.length > 36 ? `${raw.slice(0, 34)}…` : raw;
    }),
    datasets: [
      {
        label: 'Valor comprado (R$)',
        data: statsVendas.topClientes.map((c) => parseMoney(c.total)),
        backgroundColor: '#00b894'
      }
    ]
  };

  const chartOptsBase = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: true }
    }
  };

  const chartOptionsPeriodo = {
    ...chartOptsBase,
    plugins: {
      ...chartOptsBase.plugins,
      tooltip: {
        callbacks: {
          label: (ctx) => {
            const v = parseMoney(ctx.raw);
            return ` ${ctx.dataset.label || 'Total'}: ${formatCurrencyBRL(v)}`;
          }
        }
      }
    },
    scales: {
      x: {
        ticks: { maxRotation: 50, minRotation: 0, autoSkip: true, maxTicksLimit: 16 }
      },
      y: {
        beginAtZero: true,
        ticks: {
          callback: (val) => formatCurrencyBRL(val)
        }
      }
    }
  };

  const chartOptionsProdutos = {
    ...chartOptsBase,
    plugins: {
      ...chartOptsBase.plugins,
      tooltip: {
        callbacks: {
          label: (ctx) => {
            const q = Math.max(0, parseInt(ctx.raw, 10) || Number(ctx.raw) || 0);
            return ` ${ctx.dataset.label || 'Qtd'}: ${q} un.`;
          }
        }
      }
    },
    scales: {
      x: {
        ticks: { maxRotation: 45, minRotation: 0, autoSkip: true, maxTicksLimit: 12 }
      },
      y: {
        beginAtZero: true,
        ticks: {
          precision: 0,
          callback: (val) => String(Math.round(Number(val)))
        }
      }
    }
  };

  const chartOptionsClientes = {
    ...chartOptsBase,
    plugins: {
      ...chartOptsBase.plugins,
      tooltip: {
        callbacks: {
          label: (ctx) => ` ${ctx.dataset.label || 'Total'}: ${formatCurrencyBRL(ctx.raw)}`
        }
      }
    },
    scales: {
      x: {
        ticks: { maxRotation: 40, minRotation: 0, autoSkip: true, maxTicksLimit: 10 }
      },
      y: {
        beginAtZero: true,
        ticks: {
          callback: (val) => formatCurrencyBRL(val)
        }
      }
    }
  };

  const labelMetodoPrazo = (m) => {
    const s = String(m || '').toLowerCase();
    const map = { pix: 'PIX', dinheiro: 'Dinheiro', debito: 'Débito', credito: 'Crédito' };
    return map[s] || (m ? String(m) : '—');
  };

  const chartAprazoPagamentosData = {
    labels: statsAprazo.seriePagamentos.map((p) => (p.label ? String(p.label) : '—')),
    datasets: [
      {
        label: 'Pagamentos recebidos',
        data: statsAprazo.seriePagamentos.map((p) => parseMoney(p.total)),
        backgroundColor: 'rgba(0, 137, 123, 0.45)',
        borderColor: '#00b894',
        borderWidth: 1
      }
    ]
  };

  const chartAprazoNovasVendasData = {
    labels: statsAprazo.serieNovasVendas.map((p) => (p.label ? String(p.label) : '—')),
    datasets: [
      {
        label: 'Valor de novas vendas registradas',
        data: statsAprazo.serieNovasVendas.map((p) => parseMoney(p.total)),
        backgroundColor: 'rgba(102, 126, 234, 0.45)',
        borderColor: '#667eea',
        borderWidth: 1
      }
    ]
  };

  const chartAprazoMetodosData = {
    labels: statsAprazo.porMetodoPagamento.map((m) => labelMetodoPrazo(m.metodo)),
    datasets: [
      {
        label: 'Recebido por método',
        data: statsAprazo.porMetodoPagamento.map((m) => parseMoney(m.total)),
        backgroundColor: '#5f27cd'
      }
    ]
  };

  const chartAprazoClientesData = {
    labels: statsAprazo.topClientesRecebimentos.map((c) => {
      const n = String(c.nome || '—');
      return n.length > 32 ? `${n.slice(0, 30)}…` : n;
    }),
    datasets: [
      {
        label: 'Recebimentos no período',
        data: statsAprazo.topClientesRecebimentos.map((c) => parseMoney(c.total)),
        backgroundColor: '#e84393'
      }
    ]
  };

  const chartAprazoProdutosData = {
    labels: statsAprazo.topProdutos.map((p) => {
      const n = String(p.nome_produto || 'Sem nome');
      return n.length > 36 ? `${n.slice(0, 34)}…` : n;
    }),
    datasets: [
      {
        label: 'Quantidade',
        data: statsAprazo.topProdutos.map((p) => Math.max(0, parseInt(p.quantidade, 10) || 0)),
        backgroundColor: '#fdcb6e'
      }
    ]
  };

  const chartOptionsAprazoMoney = {
    ...chartOptsBase,
    plugins: {
      ...chartOptsBase.plugins,
      tooltip: {
        callbacks: {
          label: (ctx) => ` ${ctx.dataset.label || ''}: ${formatCurrencyBRL(ctx.raw)}`
        }
      }
    },
    scales: {
      x: {
        ticks: { maxRotation: 50, minRotation: 0, autoSkip: true, maxTicksLimit: 16 }
      },
      y: {
        beginAtZero: true,
        ticks: { callback: (val) => formatCurrencyBRL(val) }
      }
    }
  };

  const chartOptionsAprazoMetodos = {
    ...chartOptsBase,
    indexAxis: 'y',
    plugins: {
      ...chartOptsBase.plugins,
      tooltip: {
        callbacks: {
          label: (ctx) => ` ${formatCurrencyBRL(ctx.raw)}`
        }
      }
    },
    scales: {
      x: {
        beginAtZero: true,
        ticks: { callback: (val) => formatCurrencyBRL(val) }
      },
      y: { ticks: { autoSkip: false } }
    }
  };

  const handleImprimirRelatorioAprazo = () => {
    const periodoLabel = periodoLabelMap[periodoGraficoAprazo] || periodoGraficoAprazo;
    const geradoEm = new Date().toLocaleString('pt-BR');

    const linhasPag = statsAprazo.seriePagamentos.length
      ? statsAprazo.seriePagamentos
          .map(
            (p) => `
          <tr>
            <td>${escapeHtml(p.label)}</td>
            <td>${formatCurrencyBRL(p.total)}</td>
          </tr>`
          )
          .join('')
      : '<tr><td colspan="2">Sem pagamentos no período.</td></tr>';

    const linhasNovas = statsAprazo.serieNovasVendas.length
      ? statsAprazo.serieNovasVendas
          .map(
            (p) => `
          <tr>
            <td>${escapeHtml(p.label)}</td>
            <td>${formatCurrencyBRL(p.total)}</td>
          </tr>`
          )
          .join('')
      : '<tr><td colspan="2">Sem vendas no período.</td></tr>';

    const linhasMetodo = statsAprazo.porMetodoPagamento.length
      ? statsAprazo.porMetodoPagamento
          .map(
            (m) => `
          <tr>
            <td>${escapeHtml(labelMetodoPrazo(m.metodo))}</td>
            <td>${formatCurrencyBRL(m.total)}</td>
          </tr>`
          )
          .join('')
      : '<tr><td colspan="2">Sem dados.</td></tr>';

    const linhasCli = statsAprazo.topClientesRecebimentos.length
      ? statsAprazo.topClientesRecebimentos
          .map(
            (c) => `
          <tr>
            <td>${escapeHtml(c.nome)}</td>
            <td>${formatCurrencyBRL(c.total)}</td>
          </tr>`
          )
          .join('')
      : '<tr><td colspan="2">Sem dados.</td></tr>';

    const linhasProd = statsAprazo.topProdutos.length
      ? statsAprazo.topProdutos
          .map(
            (p) => `
          <tr>
            <td>${escapeHtml(p.nome_produto)}</td>
            <td>${Number(p.quantidade || 0)}</td>
            <td>${formatCurrencyBRL(p.total)}</td>
          </tr>`
          )
          .join('')
      : '<tr><td colspan="3">Sem dados.</td></tr>';

    const html = `
      <!doctype html>
      <html lang="pt-BR">
      <head>
        <meta charset="utf-8" />
        <title>Relatório Vendas a Prazo (loja) - Loucas por Beleza</title>
        <style>
          body { font-family: Arial, sans-serif; margin: 24px; color: #222; }
          h1, h2, h3 { margin: 0 0 10px; }
          .meta { margin-bottom: 20px; font-size: 13px; color: #555; }
          .kpis { display: grid; grid-template-columns: repeat(auto-fit, minmax(140px, 1fr)); gap: 10px; margin: 14px 0 20px; }
          .kpi { border: 1px solid #ddd; border-radius: 8px; padding: 10px; }
          .kpi strong { display: block; margin-top: 4px; font-size: 16px; }
          table { width: 100%; border-collapse: collapse; margin-bottom: 18px; }
          th, td { border: 1px solid #ddd; padding: 8px; text-align: left; font-size: 13px; }
          th { background: #f5f7fb; }
          .footer { margin-top: 24px; font-size: 12px; color: #666; }
        </style>
      </head>
      <body>
        <h1>Movimentação — Vendas a prazo (cadastro da loja)</h1>
        <div class="meta">
          <div><strong>Loja:</strong> Loucas por Beleza</div>
          <div><strong>Período:</strong> ${escapeHtml(periodoLabel)}</div>
          <div><strong>Gerado em:</strong> ${escapeHtml(geradoEm)}</div>
        </div>

        <h2>Resumo</h2>
        <div class="kpis">
          <div class="kpi">Recebido no período<strong>${formatCurrencyBRL(statsAprazo.totalPagamentosRecebidos)}</strong></div>
          <div class="kpi">Novas vendas (R$)<strong>${formatCurrencyBRL(statsAprazo.totalNovasVendasValor)}</strong></div>
          <div class="kpi">Vendas registradas<strong>${statsAprazo.vendasRegistradasNoPeriodo}</strong></div>
          <div class="kpi">Saldo em aberto (atual)<strong>${formatCurrencyBRL(statsAprazo.saldoEmAberto)}</strong></div>
          <div class="kpi">Vendas em aberto<strong>${statsAprazo.vendasAbertasCount}</strong></div>
        </div>

        <h2>Pagamentos recebidos por intervalo</h2>
        <table>
          <thead><tr><th>Intervalo</th><th>Total</th></tr></thead>
          <tbody>${linhasPag}</tbody>
        </table>

        <h2>Novas vendas registradas (valor total) por intervalo</h2>
        <table>
          <thead><tr><th>Intervalo</th><th>Total</th></tr></thead>
          <tbody>${linhasNovas}</tbody>
        </table>

        <h2>Recebimentos por método de pagamento</h2>
        <table>
          <thead><tr><th>Método</th><th>Total</th></tr></thead>
          <tbody>${linhasMetodo}</tbody>
        </table>

        <h2>Clientes — maiores recebimentos no período</h2>
        <table>
          <thead><tr><th>Cliente</th><th>Total recebido</th></tr></thead>
          <tbody>${linhasCli}</tbody>
        </table>

        <h2>Produtos mais vendidos (vendas a prazo no período)</h2>
        <table>
          <thead><tr><th>Produto</th><th>Qtd</th><th>Total</th></tr></thead>
          <tbody>${linhasProd}</tbody>
        </table>

        <p class="footer">Relatório das vendas a prazo cadastradas no painel (não inclui pedidos do e-commerce).</p>
      </body>
      </html>
    `;

    const printWindow = window.open('', '_blank', 'width=1024,height=768');
    if (!printWindow) {
      toast.error('Não foi possível abrir a janela de impressão.');
      return;
    }
    printWindow.document.open();
    printWindow.document.write(html);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  };

  const pedidoStatusLabel = {
    pendente: 'Pendente',
    confirmado: 'Confirmado',
    cancelado: 'Cancelado',
    aguardando_aprovacao: 'Aguardando aprovação',
    cancelamento_solicitado: 'Cancelamento solicitado'
  };

  useEffect(() => {
    if (produtos.length > 0) {
      // Atualizar estatísticas
      setStats({
        totalProdutos: produtos.length,
        totalClientes: clientes.length,
        produtosAtivos: produtos.filter(p => p.ativo).length,
        produtosOferta: produtos.filter(p => p.preco_anterior && parseFloat(p.preco_anterior) > parseFloat(p.preco)).length
      });
      loadCarouselProdutos();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [produtos, clientes]);

  return (
    <div className="dashboard-admin">
      <div className="dashboard-header">
        <div className="container">
          <h1>Dashboard Administrativo</h1>
          <div className="admin-info">
            <span>Bem-vindo, {cliente.nome || 'Administrador'}</span>
            <button
              type="button"
              className={`btn-pedidos-header ${novasCompras > 0 ? 'has-new' : ''}`}
              onClick={abrirTelaVendas}
              title="Abrir vendas e pedidos"
              aria-label="Abrir vendas e pedidos"
            >
              📦
              {novasCompras > 0 && <span className="pedidos-badge">{novasCompras > 99 ? '99+' : novasCompras}</span>}
            </button>
            <button onClick={handleLogout} className="btn-logout">Sair</button>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="dashboard-tabs">
          <button 
            className={activeTab === 'dashboard' ? 'active' : ''}
            onClick={() => setActiveTab('dashboard')}
          >
            📊 Dashboard
          </button>
          <button 
            className={activeTab === 'cadastro' ? 'active' : ''}
            onClick={() => setActiveTab('cadastro')}
          >
            ➕ Cadastrar Produto
          </button>
          <button 
            className={activeTab === 'produtos' ? 'active' : ''}
            onClick={() => setActiveTab('produtos')}
          >
            📦 Gerenciar Produtos
          </button>
          <button
            className={activeTab === 'estoque' ? 'active' : ''}
            onClick={() => setActiveTab('estoque')}
          >
            📚 Estoque
          </button>
          <button 
            className={activeTab === 'clientes' ? 'active' : ''}
            onClick={() => setActiveTab('clientes')}
          >
            👥 Clientes
          </button>
          <button 
            className={activeTab === 'carousel' ? 'active' : ''}
            onClick={() => setActiveTab('carousel')}
          >
            🎠 Controle do Carrossel
          </button>
          <button 
            className={activeTab === 'carouselInicial' ? 'active' : ''}
            onClick={() => setActiveTab('carouselInicial')}
          >
            🖼️ Carrossel inicial
          </button>
          <button 
            className={activeTab === 'categorias' ? 'active' : ''}
            onClick={() => setActiveTab('categorias')}
          >
            🏷️ Categorias
          </button>
          <button 
            className={activeTab === 'vendas' ? 'active' : ''}
            onClick={() => setActiveTab('vendas')}
          >
            💰 Vendas
          </button>
          <button
            className={activeTab === 'aprazo' ? 'active' : ''}
            onClick={() => setActiveTab('aprazo')}
          >
            🧾 A Prazo
          </button>
          <button
            className={activeTab === 'graficosAprazo' ? 'active' : ''}
            onClick={() => {
              setVendaStep(null);
              setActiveTab('graficosAprazo');
            }}
          >
            📊 Gráficos A Prazo
          </button>
          <button
            className={activeTab === 'graficos' ? 'active' : ''}
            onClick={() => {
              setVendaStep(null);
              setActiveTab('graficos');
            }}
          >
            📈 Gráficos
          </button>
          <button
            className={activeTab === 'relatorioImpresso' ? 'active' : ''}
            onClick={abrirRelatorioImpresso}
          >
            🖨️ Relatório Impresso
          </button>
        </div>

        <div className="dashboard-content">
          {activeTab === 'dashboard' && (
            <div className="dashboard-overview">
              <h2>Visão Geral</h2>
              <div className="stats-grid">
                <div className="stat-card">
                  <div className="stat-icon">📦</div>
                  <div className="stat-info">
                    <h3>{stats.totalProdutos}</h3>
                    <p>Total de Produtos</p>
                  </div>
                </div>
                <div className="stat-card">
                  <div className="stat-icon">✅</div>
                  <div className="stat-info">
                    <h3>{stats.produtosAtivos}</h3>
                    <p>Produtos Ativos</p>
                  </div>
                </div>
                <div className="stat-card">
                  <div className="stat-icon">👥</div>
                  <div className="stat-info">
                    <h3>{stats.totalClientes}</h3>
                    <p>Clientes Cadastrados</p>
                  </div>
                </div>
                <div className="stat-card">
                  <div className="stat-icon">🔥</div>
                  <div className="stat-info">
                    <h3>{stats.produtosOferta}</h3>
                    <p>Produtos em Oferta</p>
                  </div>
                </div>
              </div>
              <div className="quick-actions">
                <h3>Ações Rápidas</h3>
                <div className="actions-grid">
                  <button onClick={() => setActiveTab('cadastro')} className="action-btn">
                    ➕ Cadastrar Novo Produto
                  </button>
                  <button onClick={() => setActiveTab('produtos')} className="action-btn">
                    📦 Gerenciar Produtos
                  </button>
                  <button onClick={() => setActiveTab('clientes')} className="action-btn">
                    👥 Ver Clientes
                  </button>
                  <button onClick={() => setActiveTab('carousel')} className="action-btn">
                    🎠 Configurar Carrossel
                  </button>
                  <button onClick={() => setActiveTab('carouselInicial')} className="action-btn">
                    🖼️ Carrossel inicial
                  </button>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'carouselInicial' && (
            <div className="carousel-inicial-container">
              {apiReachable === false && (
                <div className="carousel-api-alert" role="alert">
                  <strong>Rota de upload não encontrada (404).</strong> No servidor, execute para corrigir: <code>sudo bash /var/www/loucasporbeleza.com.br/scripts/configurar-apache-proxy.sh --auto</code>. Ou edite o VirtualHost do Apache e inclua <code>Include .../apache-proxy-api.conf</code>. Veja <code>CONFIGURAR-APACHE-PROXY.md</code> no projeto.
                </div>
              )}
              <h2>Carrossel inicial</h2>
              <p className="carousel-info">
                Configure as imagens e as mensagens exibidas no carrossel da página inicial. As mensagens aparecem no centro da foto.
              </p>
              <p className="carousel-dimensoes">
                Dimensão recomendada da foto: <strong>{CAROUSEL_DIMENSOES} px</strong> (largura × altura) para o tamanho correto no carrossel.
              </p>
              <div className="carousel-inicial-interval">
                <label htmlFor="carousel-interval">Intervalo de troca (segundos)</label>
                <input
                  id="carousel-interval"
                  type="number"
                  min="2"
                  max="60"
                  value={carouselInicial.interval / 1000}
                  onChange={(e) => {
                    const sec = Math.max(2, Math.min(60, Number(e.target.value) || 5));
                    setCarouselInicial((prev) => ({ ...prev, interval: sec * 1000 }));
                  }}
                />
              </div>
              <div className="carousel-inicial-slides">
                <div className="carousel-inicial-slides-header">
                  <h3>Slides ({carouselInicial.slides.length})</h3>
                  <div className="carousel-inicial-header-btns">
                    <button type="button" onClick={handleSaveCarouselInicial} className="btn-salvar-carousel" disabled={savingCarousel}>
                      {savingCarousel ? 'Salvando…' : '💾 Salvar alterações'}
                    </button>
                    <button type="button" onClick={addSlideCarouselInicial} className="btn-add-slide">
                      + Adicionar slide
                    </button>
                  </div>
                </div>
                <input
                  ref={carouselFileInputRef}
                  type="file"
                  accept="image/jpeg,image/png,image/gif,image/webp"
                  onChange={onCarouselFileChange}
                  className="carousel-file-input-hidden"
                  aria-hidden="true"
                />
                <input
                  ref={carouselUploadFullRef}
                  type="file"
                  accept="image/jpeg,image/png,image/gif,image/webp"
                  onChange={onCarouselUploadFullChange}
                  className="carousel-file-input-hidden"
                  aria-hidden="true"
                />
                {carouselInicial.slides.length === 0 ? (
                  <p className="no-slides">Nenhum slide. Clique em &quot;Adicionar slide&quot;, use <strong>Upload</strong> (imagem inteira em {CAROUSEL_DIMENSOES} px) ou <strong>Recortar</strong>, e opcionalmente preencha título e subtítulo.</p>
                ) : (
                  <div className="carousel-inicial-list">
                    {carouselInicial.slides.map((slide, index) => (
                      <div key={slide.id} className="carousel-inicial-slide-card">
                        <div className="carousel-inicial-slide-preview">
                          {slide.image ? (
                            <img src={getImageUrl(slide.image)} alt="" onError={(e) => { e.target.src = getImageUrl(PLACEHOLDER_IMAGE); }} />
                          ) : (
                            <div className="carousel-inicial-placeholder">Upload acima</div>
                          )}
                        </div>
                        <div className="carousel-inicial-slide-fields">
                          <div className="carousel-upload-row">
                            <button type="button" onClick={() => openUploadFull(index)} className="btn-upload-carousel btn-upload-full" disabled={uploadingCarouselImage}>
                              {uploadingCarouselImage && uploadFullForSlideIndex === index ? 'Enviando…' : '📤 Upload'}
                            </button>
                            <button type="button" onClick={() => openCropModal(index)} className="btn-upload-carousel btn-upload-crop" disabled={uploadingCarouselImage}>
                              {uploadingCarouselImage && cropModalSlideIndex === index ? 'Enviando…' : '✂️ Recortar'}
                            </button>
                            <button type="button" onClick={handleSaveCarouselInicial} className="btn-salvar-slide" title="Salvar alterações do carrossel no servidor" disabled={savingCarousel}>
                              💾 Salvar
                            </button>
                            <span className="carousel-url-ou">ou URL:</span>
                            <input
                              type="url"
                              placeholder="URL da imagem (opcional)"
                              value={slide.image && slide.image.startsWith('http') ? slide.image : ''}
                              onChange={(e) => updateSlideCarouselInicial(index, 'image', e.target.value)}
                              className="carousel-url-input"
                            />
                          </div>
                          <input
                            type="text"
                            placeholder="Título (exibido no centro da foto)"
                            value={slide.title || ''}
                            onChange={(e) => updateSlideCarouselInicial(index, 'title', e.target.value)}
                          />
                          <input
                            type="text"
                            placeholder="Subtítulo (exibido no centro da foto)"
                            value={slide.subtitle || ''}
                            onChange={(e) => updateSlideCarouselInicial(index, 'subtitle', e.target.value)}
                          />
                        </div>
                        <div className="carousel-inicial-slide-actions">
                          <button type="button" onClick={() => moveSlideCarouselInicial(index, 'up')} disabled={index === 0} title="Subir">↑</button>
                          <button type="button" onClick={() => moveSlideCarouselInicial(index, 'down')} disabled={index === carouselInicial.slides.length - 1} title="Descer">↓</button>
                          <button type="button" onClick={() => removeSlideCarouselInicial(index)} className="remove-btn" title="Remover">✕</button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                {cropModalOpen && cropModalSrc && (
                  <CarouselImageCropModal
                    src={cropModalSrc}
                    onConfirm={onCropConfirm}
                    onCancel={onCropCancel}
                  />
                )}
              </div>
            </div>
          )}

          {activeTab === 'cadastro' && (
            <div className="cadastro-form-container">
              <h2>{editingProduto ? 'Editar Produto' : 'Cadastrar Novo Produto'}</h2>
              {editingProduto && (
                <div className="editing-notice">
                  <p>✏️ Editando: <strong>{editingProduto.nome}</strong></p>
                  <button type="button" onClick={handleCancelEdit} className="btn-cancel-edit">
                    Cancelar Edição
                  </button>
                </div>
              )}
              
              <form onSubmit={handleSubmit} className="produto-form">
                <div className="form-group">
                  <label htmlFor="nome">Nome do Produto *</label>
                  <input
                    type="text"
                    id="nome"
                    name="nome"
                    value={formData.nome}
                    onChange={handleChange}
                    required
                    placeholder="Digite o nome do produto"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="descricao">Descrição *</label>
                  <textarea
                    id="descricao"
                    name="descricao"
                    value={formData.descricao}
                    onChange={handleChange}
                    required
                    rows="5"
                    placeholder="Descreva o produto"
                  />
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="preco">Preço *</label>
                    <input
                      type="number"
                      id="preco"
                      name="preco"
                      value={formData.preco}
                      onChange={handleChange}
                      required
                      step="0.01"
                      min="0"
                      placeholder="0.00"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="preco_anterior">Preço Anterior (opcional)</label>
                    <input
                      type="number"
                      id="preco_anterior"
                      name="preco_anterior"
                      value={formData.preco_anterior}
                      onChange={handleChange}
                      step="0.01"
                      min="0"
                      placeholder="0.00"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="categoria_id">Categoria *</label>
                    <select
                      id="categoria_id"
                      name="categoria_id"
                      value={formData.categoria_id}
                      onChange={handleChange}
                      required
                      className="form-select"
                    >
                      <option value="">Selecione uma categoria</option>
                      {categorias.map(categoria => (
                        <option key={categoria.id} value={categoria.id}>
                          {categoria.icone} {categoria.nome}
                        </option>
                      ))}
                    </select>
                    {categorias.length === 0 && (
                      <p className="form-hint">
                        Nenhuma categoria cadastrada. <button 
                          type="button" 
                          onClick={() => setActiveTab('categorias')}
                          className="link-button"
                        >
                          Cadastrar categoria
                        </button>
                      </p>
                    )}
                  </div>

                  {formData.categoria_id && (
                    <div className="form-group">
                      <label htmlFor="subcategoria_id">Subcategoria</label>
                      <select
                        id="subcategoria_id"
                        name="subcategoria_id"
                        value={formData.subcategoria_id}
                        onChange={handleChange}
                        className="form-select"
                      >
                        <option value="">Nenhuma</option>
                        {subcategoriasPorCategoria.map(sub => (
                          <option key={sub.id} value={sub.id}>{sub.nome}</option>
                        ))}
                      </select>
                    </div>
                  )}

                  <div className="form-group">
                    <label htmlFor="quantidade">Quantidade em Estoque</label>
                    <input
                      type="number"
                      id="quantidade"
                      name="quantidade"
                      value={formData.quantidade}
                      onChange={handleChange}
                      min="0"
                      placeholder="0"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="fotos">
                    Fotos do Produto {isColoration ? `(até ${MAX_FOTOS_COLORACAO} imagens — coloração)` : '(até 5 imagens)'}
                  </label>
                  <input
                    type="file"
                    id="fotos"
                    name="fotos"
                    onChange={handleFileChange}
                    accept="image/*"
                    multiple
                  />
                  <p className="form-hint">
                    {isColoration ? 'Produto de coloração: você pode adicionar várias imagens (uma por tom/cor se quiser). Formatos: JPG, PNG, GIF, WEBP.' : 'Até 5 imagens. Formatos: JPG, PNG, GIF, WEBP'}
                  </p>
                  
                  {/* Preview das novas fotos selecionadas */}
                  {fotos.length > 0 && (
                    <div className="fotos-preview">
                      <h4>Novas fotos ({fotos.length}/{maxFotosProduto}) — use ↑↓ para ordenar:</h4>
                      <div className="fotos-grid-ordenavel">
                        {fotos.map((foto, index) => (
                          <div key={index} className="foto-preview-item-ordenavel">
                            <div className="foto-ordem-controls">
                              <button
                                type="button"
                                onClick={() => moveFoto(index, 'up')}
                                className="btn-move-foto"
                                disabled={index === 0}
                                title="Mover para cima"
                              >
                                ↑
                              </button>
                              <span className="foto-ordem-numero">{index + 1}</span>
                              <button
                                type="button"
                                onClick={() => moveFoto(index, 'down')}
                                className="btn-move-foto"
                                disabled={index === fotos.length - 1}
                                title="Mover para baixo"
                              >
                                ↓
                              </button>
                            </div>
                            <img 
                              src={URL.createObjectURL(foto)}
                              alt={`Preview ${index + 1}`}
                              className="foto-preview-thumb"
                            />
                            <button
                              type="button"
                              onClick={() => removeFoto(index)}
                              className="btn-remove-foto"
                              title="Remover foto"
                            >
                              ✕
                            </button>
                            <p className="foto-name">{foto.name}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  
                  {/* Fotos existentes (ao editar) */}
                  {editingProduto && fotosExistentes.length > 0 && (
                    <div className="fotos-existentes">
                      <h4>Fotos atuais ({fotosExistentes.length}/{maxFotosProduto}) — use ↑↓ para ordenar:</h4>
                      <div className="fotos-grid-ordenavel">
                        {fotosExistentes.map((fotoUrl, index) => (
                          <div key={index} className="foto-preview-item-ordenavel">
                            <div className="foto-ordem-controls">
                              <button
                                type="button"
                                onClick={() => moveFotoExistente(index, 'up')}
                                className="btn-move-foto"
                                disabled={index === 0}
                                title="Mover para cima"
                              >
                                ↑
                              </button>
                              <span className="foto-ordem-numero">{index + 1}</span>
                              <button
                                type="button"
                                onClick={() => moveFotoExistente(index, 'down')}
                                className="btn-move-foto"
                                disabled={index === fotosExistentes.length - 1}
                                title="Mover para baixo"
                              >
                                ↓
                              </button>
                            </div>
                            <img 
                              src={fotoUrl.startsWith('http') ? fotoUrl : `https://www.loucasporbeleza.com.br${fotoUrl}`}
                              alt={`Foto ${index + 1}`}
                              className="foto-preview-thumb"
                              onError={(e) => {
                                e.target.style.display = 'none';
                              }}
                            />
                            <button
                              type="button"
                              onClick={() => removeFotoExistente(fotoUrl)}
                              className="btn-remove-foto"
                              title="Remover foto"
                            >
                              ✕
                            </button>
                            <p className="foto-name">Foto {index + 1}</p>
                          </div>
                        ))}
                      </div>
                      <p className="photo-hint">Use as setas ↑↓ para ordenar as fotos. A primeira foto será a principal. Clique no ✕ para remover.</p>
                    </div>
                  )}
                  
                  {/* Mensagem quando não há fotos */}
                  {!editingProduto && fotos.length === 0 && (
                    <p className="form-hint">Nenhuma foto selecionada ainda.</p>
                  )}
                </div>

                {/* Variações do produto (cor/tamanho/etc) */}
                <div className="form-group produto-cores-admin">
                      <h4>Subprodutos / variações do produto</h4>
                      <p className="form-hint">Cadastre as opções do produto (ex.: Preto 1.0, Loiro 8.0, Tamanho P, Tamanho M). Você pode informar descrição e imagem da opção.</p>
                      {!editingProduto ? (
                        <>
                          <p className="form-hint aviso-cores">Adicione as variações agora. Elas serão salvas automaticamente quando você cadastrar o produto.</p>
                          <p className="form-hint form-add-cor-hint">Adicionar variação para o novo produto:</p>
                          <form onSubmit={handleAddCor} className="form-add-cor">
                            <input
                              ref={corDescricaoInputRef}
                              type="text"
                              placeholder="Descrição da variação (ex: Preto 1.0, Tamanho M)"
                              value={corForm.descricao_cor}
                              onChange={(e) => setCorForm({ ...corForm, descricao_cor: e.target.value })}
                              className="input-descricao-cor"
                            />
                            <div className="cor-foto-field">
                              <input
                                ref={corFotoInputRef}
                                type="file"
                                accept="image/*"
                                onChange={(e) => setCorForm({ ...corForm, foto: e.target.files?.[0] })}
                                className="input-foto-cor"
                              />
                              {corForm.foto && (
                                <div className="cor-foto-preview">
                                  <span className="cor-foto-selecionado">Arquivo selecionado: {corForm.foto.name}</span>
                                  {corPreviewUrl && (
                                    <div className="cor-foto-preview-box">
                                      <img src={corPreviewUrl} alt="Preview" className="cor-foto-preview-img" />
                                      {corForm.descricao_cor && (
                                        <span className="cor-foto-preview-desc">{corForm.descricao_cor}</span>
                                      )}
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                            <button type="submit" className="btn-submit btn-add-cor">Adicionar variação</button>
                          </form>
                          {coresPendentes.length > 0 && (
                            <>
                              <h5 className="cores-cadastradas-title">Variações na fila ({coresPendentes.length})</h5>
                              <div className="produto-cores-quadradinhos">
                                {coresPendentes.map((cor, index) => (
                                  <div key={cor.id} className="produto-cor-quadradinho">
                                    <span className="produto-cor-ordem-numero">{index + 1}</span>
                                    <span className="produto-cor-desc-admin">{cor.descricao_cor}</span>
                                    <p className="foto-name">{cor.foto?.name || 'Foto da variação'}</p>
                                    <button type="button" onClick={() => handleRemoveCorPendente(cor.id)} className="btn-remove-foto btn-remove-cor" title="Remover variação">✕</button>
                                  </div>
                                ))}
                              </div>
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          <p className="form-hint form-add-cor-hint">Adicionar nova variação (aparecerá na lista abaixo):</p>
                          {loadingCor && (
                            <div className="cor-add-loading">
                              <span className="cor-add-loading-spinner" />
                              <span>Enviando imagem e salvando variação...</span>
                            </div>
                          )}
                          <form onSubmit={handleAddCor} className="form-add-cor">
                            <input
                              ref={corDescricaoInputRef}
                              type="text"
                              placeholder="Descrição da variação (ex: Preto 1.0, Tamanho M)"
                              value={corForm.descricao_cor}
                              onChange={(e) => setCorForm({ ...corForm, descricao_cor: e.target.value })}
                              className="input-descricao-cor"
                              disabled={loadingCor}
                            />
                            <div className="cor-foto-field">
                              <input
                                ref={corFotoInputRef}
                                type="file"
                                accept="image/*"
                                onChange={(e) => setCorForm({ ...corForm, foto: e.target.files?.[0] })}
                                className="input-foto-cor"
                                disabled={loadingCor}
                              />
                              {corForm.foto && (
                                <div className="cor-foto-preview">
                                  <span className="cor-foto-selecionado">Arquivo selecionado: {corForm.foto.name}</span>
                                  {corPreviewUrl && (
                                    <div className="cor-foto-preview-box">
                                      <img src={corPreviewUrl} alt="Preview" className="cor-foto-preview-img" />
                                      {corForm.descricao_cor && (
                                        <span className="cor-foto-preview-desc">{corForm.descricao_cor}</span>
                                      )}
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                            <button type="submit" className="btn-submit btn-add-cor" disabled={loadingCor}>
                              {loadingCor ? 'Enviando...' : 'Adicionar variação'}
                            </button>
                          </form>
                          {produtoCores.length > 0 && (
                            <>
                              <h5 className="cores-cadastradas-title">Variações cadastradas ({produtoCores.length}) — use ↑↓ para ordenar</h5>
                              <div className="produto-cores-quadradinhos">
                                {produtoCores.map((cor, index) => (
                                  <div key={cor.id} className="produto-cor-quadradinho">
                                    <div className="produto-cor-ordem-controls">
                                      <button type="button" onClick={() => handleMoveCor(index, 'up')} className="btn-move-cor" disabled={index === 0} title="Subir">↑</button>
                                      <span className="produto-cor-ordem-numero">{index + 1}</span>
                                      <button type="button" onClick={() => handleMoveCor(index, 'down')} className="btn-move-cor" disabled={index === produtoCores.length - 1} title="Descer">↓</button>
                                    </div>
                                    <img
                                      src={getImageUrl(cor.foto)}
                                      alt={cor.descricao_cor}
                                      className="produto-cor-thumb-admin"
                                    />
                                    <span className="produto-cor-desc-admin">{cor.descricao_cor}</span>
                                    <button type="button" onClick={() => handleRemoveCor(cor.id)} className="btn-remove-foto btn-remove-cor" title="Remover variação">✕</button>
                                  </div>
                                ))}
                              </div>
                            </>
                          )}
                        </>
                      )}
                    </div>

                <div className="form-actions">
                  <button type="submit" className="btn-submit" disabled={loading}>
                    {loading 
                      ? (editingProduto ? 'Atualizando...' : 'Cadastrando...') 
                      : (editingProduto ? 'Atualizar Produto' : 'Cadastrar Produto')
                    }
                  </button>
                  {editingProduto && (
                    <button type="button" onClick={handleCancelEdit} className="btn-cancel">
                      Cancelar
                    </button>
                  )}
                </div>
              </form>

              <div className="cadastro-produtos-preview">
                <div className="produtos-header-section">
                  <h3>Produtos cadastrados</h3>
                  <div className="produtos-count">{produtos.length} {produtos.length === 1 ? 'produto' : 'produtos'}</div>
                </div>
                {loadingProdutos ? (
                  <p>Carregando produtos...</p>
                ) : produtos.length === 0 ? (
                  <p className="no-data">Nenhum produto cadastrado ainda.</p>
                ) : (
                  <div className="produtos-grid-admin">
                    {produtos.map((produto) => (
                      <div key={produto.id} className="produto-card-admin">
                        <div className="produto-image-wrapper">
                          {((produto.fotos && produto.fotos[0]) || produto.foto) ? (
                            <img
                              src={getImageUrl((produto.fotos && produto.fotos[0]) || produto.foto)}
                              alt={produto.nome}
                              className="produto-image"
                            />
                          ) : (
                            <div className="produto-image-placeholder">
                              <span>📦</span>
                              <p>Sem imagem</p>
                            </div>
                          )}
                        </div>
                        <div className="produto-info-admin">
                          <h4 className="produto-nome-admin">{produto.nome}</h4>
                          <div className="produto-preco-section">
                            <span className="produto-preco-atual">R$ {parseFloat(produto.preco || 0).toFixed(2)}</span>
                          </div>
                          <div className="produto-actions">
                            <button
                              type="button"
                              className="btn-edit-admin"
                              onClick={() => handleEdit(produto.id)}
                              title="Editar produto"
                            >
                              ✏️ Editar
                            </button>
                            <button
                              type="button"
                              className="btn-delete-admin"
                              onClick={() => handleDelete(produto.id, produto.nome)}
                              title="Deletar produto"
                            >
                              🗑️ Deletar
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          )}

          {activeTab === 'produtos' && (
            <div className="produtos-list-container">
              <div className="produtos-header-section">
                <h2>Produtos Cadastrados</h2>
                <div className="produtos-count">{produtos.length} {produtos.length === 1 ? 'produto' : 'produtos'}</div>
              </div>
              
              {loadingProdutos ? (
                <div className="loading-state">
                  <div className="spinner"></div>
                  <p>Carregando produtos...</p>
                </div>
              ) : produtos.length > 0 ? (
                <div className="produtos-grid-admin">
                  {produtos.map((produto) => (
                    <div key={produto.id} className="produto-card-admin">
                      <div className="produto-image-wrapper">
                        {(() => {
                          const fotosProduto = produto.fotos || (produto.foto ? [produto.foto] : []);
                          if (fotosProduto.length > 0) {
                            return (
                              <div className="produto-galeria">
                                <img 
                                  src={fotosProduto[0].startsWith('http') ? fotosProduto[0] : `https://www.loucasporbeleza.com.br${fotosProduto[0]}`}
                                  alt={produto.nome}
                                  className="produto-image"
                                  onError={(e) => {
                                    e.target.src = getImageUrl(PLACEHOLDER_IMAGE);
                                  }}
                                />
                                {fotosProduto.length > 1 && (
                                  <div className="produto-fotos-count">
                                    <span>📷 {fotosProduto.length}</span>
                                  </div>
                                )}
                              </div>
                            );
                          } else {
                            return (
                              <div className="produto-image-placeholder">
                                <span>📦</span>
                                <p>Sem imagem</p>
                              </div>
                            );
                          }
                        })()}
                        {produto.preco_anterior && parseFloat(produto.preco_anterior) > parseFloat(produto.preco) && (
                          <span className="produto-badge-oferta">OFERTA</span>
                        )}
                      </div>
                      <div className="produto-info-admin">
                        <h3 className="produto-nome-admin" title={produto.nome}>
                          {produto.nome}
                        </h3>
                        {produto.categoria && (
                          <span className="produto-categoria-badge">{produto.categoria}</span>
                        )}
                        <div className="produto-preco-section">
                          {produto.preco_anterior && parseFloat(produto.preco_anterior) > parseFloat(produto.preco) && (
                            <span className="produto-preco-antigo">R$ {parseFloat(produto.preco_anterior).toFixed(2)}</span>
                          )}
                          <span className="produto-preco-atual">R$ {parseFloat(produto.preco).toFixed(2)}</span>
                        </div>
                        {produto.estoque_quantidade !== undefined && (
                          <div className="produto-estoque">
                            <span className={produto.estoque_quantidade > 0 ? 'estoque-disponivel' : 'estoque-indisponivel'}>
                              {produto.estoque_quantidade > 0 ? `✓ Em estoque (${produto.estoque_quantidade})` : '✗ Fora de estoque'}
                            </span>
                          </div>
                        )}
                        <div className="produto-actions">
                          <button 
                            onClick={() => handleEdit(produto.id)}
                            className="btn-edit-admin"
                            title="Editar produto"
                          >
                            ✏️ Editar
                          </button>
                          <button 
                            onClick={() => handleDelete(produto.id)}
                            className="btn-delete-admin"
                            title="Deletar produto"
                          >
                            🗑️ Deletar
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="empty-state">
                  <p>📦 Nenhum produto cadastrado ainda.</p>
                  <button onClick={() => setActiveTab('cadastro')} className="btn-add-first">
                    Cadastrar Primeiro Produto
                  </button>
                </div>
              )}
            </div>
          )}

          {activeTab === 'clientes' && (
            <div className="clientes-container">
              <h2>Clientes Cadastrados</h2>
              {loadingClientes ? (
                <p>Carregando clientes...</p>
              ) : (
                <div className="clientes-table">
                  <table>
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Nome</th>
                        <th>Email</th>
                        <th>Telefone</th>
                        <th>Cidade</th>
                        <th>Estado</th>
                        <th>Data Cadastro</th>
                      </tr>
                    </thead>
                    <tbody>
                      {clientes.map(cliente => (
                        <tr key={cliente.id}>
                          <td>{cliente.id}</td>
                          <td>{cliente.nome}</td>
                          <td>{cliente.email}</td>
                          <td>{cliente.telefone || '-'}</td>
                          <td>{cliente.cidade || '-'}</td>
                          <td>{cliente.estado || '-'}</td>
                          <td>{new Date(cliente.created_at).toLocaleDateString('pt-BR')}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {clientes.length === 0 && (
                    <p className="no-data">Nenhum cliente cadastrado ainda.</p>
                  )}
                </div>
              )}
            </div>
          )}

          {activeTab === 'estoque' && (
            <div className="estoque-container">
              <h2>Controle de Estoque</h2>
              <p className="estoque-desc">Ajuste apenas quantidades de estoque. Os preços de venda não são alterados aqui.</p>
              <div className="estoque-lote-actions">
                <input
                  type="text"
                  className="estoque-lote-motivo"
                  placeholder="Motivo do ajuste em lote (opcional)"
                  value={motivoLote}
                  onChange={(e) => setMotivoLote(e.target.value)}
                />
                <button type="button" className="btn-save-estoque lote" onClick={handleSalvarLoteEstoque} disabled={savingLote}>
                  {savingLote ? 'Salvando lote...' : 'Salvar selecionados (lote)'}
                </button>
              </div>
              {loadingEstoque ? (
                <p>Carregando estoque...</p>
              ) : estoqueProdutos.length === 0 ? (
                <p className="no-data">Nenhum produto encontrado.</p>
              ) : (
                <div className="estoque-table-wrap">
                  <table className="estoque-table">
                    <thead>
                      <tr>
                        <th>Sel.</th>
                        <th>Produto</th>
                        <th>Preço venda</th>
                        <th>Preço compra</th>
                        <th>Qtd atual</th>
                        <th>Qtd mínima</th>
                        <th>Status</th>
                        <th>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {estoqueProdutos.map((item) => {
                        const qtd = Math.max(0, parseInt(item.quantidade, 10) || 0);
                        const qtdMin = Math.max(0, parseInt(item.quantidade_minima, 10) || 0);
                        const baixo = qtd <= qtdMin;
                        return (
                          <tr key={item.produto_id}>
                            <td>
                              <input
                                type="checkbox"
                                checked={!!estoqueSelecionados[item.produto_id]}
                                onChange={() => toggleSelecionadoEstoque(item.produto_id)}
                              />
                            </td>
                            <td>{item.produto_nome}</td>
                            <td>
                              <input
                                type="number"
                                min="0"
                                step="0.01"
                                value={item.preco_venda ?? 0}
                                onChange={(e) => handleEstoqueFieldChange(item.produto_id, 'preco_venda', e.target.value)}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                min="0"
                                step="0.01"
                                value={item.preco_compra ?? ''}
                                onChange={(e) => handleEstoqueFieldChange(item.produto_id, 'preco_compra', e.target.value)}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                min="0"
                                value={item.quantidade}
                                onChange={(e) => handleEstoqueFieldChange(item.produto_id, 'quantidade', e.target.value)}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                min="0"
                                value={item.quantidade_minima}
                                onChange={(e) => handleEstoqueFieldChange(item.produto_id, 'quantidade_minima', e.target.value)}
                              />
                            </td>
                            <td>
                              <span className={`estoque-status ${baixo ? 'baixo' : 'ok'}`}>
                                {baixo ? 'Baixo' : 'OK'}
                              </span>
                            </td>
                            <td>
                              <button
                                type="button"
                                className="btn-save-estoque"
                                onClick={() => handleSalvarEstoqueProduto(item.produto_id)}
                                disabled={savingEstoqueProdutoId === item.produto_id}
                              >
                                {savingEstoqueProdutoId === item.produto_id ? 'Salvando...' : 'Salvar'}
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}

              <div className="estoque-mov-container">
                <h3>Histórico de movimentações</h3>
                {loadingMovEstoque ? (
                  <p>Carregando movimentações...</p>
                ) : movimentacoesEstoque.length === 0 ? (
                  <p className="no-data">Sem movimentações registradas.</p>
                ) : (
                  <div className="estoque-table-wrap">
                    <table className="estoque-table">
                      <thead>
                        <tr>
                          <th>Data</th>
                          <th>Produto</th>
                          <th>Tipo</th>
                          <th>Anterior</th>
                          <th>Novo</th>
                          <th>Delta</th>
                          <th>Motivo</th>
                        </tr>
                      </thead>
                      <tbody>
                        {movimentacoesEstoque.map((mov) => (
                          <tr key={mov.id}>
                            <td>{mov.created_at ? new Date(mov.created_at).toLocaleString('pt-BR') : '-'}</td>
                            <td>{mov.produto_nome || `#${mov.produto_id}`}</td>
                            <td>{mov.tipo}</td>
                            <td>{mov.quantidade_anterior}</td>
                            <td>{mov.quantidade_nova}</td>
                            <td>{mov.quantidade_delta > 0 ? `+${mov.quantidade_delta}` : mov.quantidade_delta}</td>
                            <td>{mov.motivo || '-'}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          )}

          {activeTab === 'carousel' && (
            <div className="carousel-control-container">
              <h2>Controle do Carrossel</h2>
              <p className="carousel-info">
                Selecione até 5 produtos para exibir no carrossel da página inicial.
              </p>
              {loadingProdutos ? (
                <p>Carregando produtos...</p>
              ) : (
                <div className="carousel-selection">
                  <div className="selected-products">
                    <h3>Produtos Selecionados ({carouselProdutos.length}/5)</h3>
                    <div className="selected-list">
                      {carouselProdutos.map(produto => (
                        <div key={produto.id} className="selected-item">
                          <img 
                            src={produto.foto?.startsWith('http') ? produto.foto : `https://www.loucasporbeleza.com.br${produto.foto}`}
                            alt={produto.nome}
                            onError={(e) => e.target.style.display = 'none'}
                          />
                          <span>{produto.nome}</span>
                          <button 
                            onClick={() => {
                              const newList = carouselProdutos.filter(p => p.id !== produto.id);
                              updateCarousel(newList.map(p => p.id));
                            }}
                            className="remove-btn"
                          >
                            ✕
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="available-products">
                    <h3>Produtos Disponíveis</h3>
                    <div className="products-checkbox-list">
                      {produtos.map(produto => {
                        const isSelected = carouselProdutos.some(p => p.id === produto.id);
                        return (
                          <label key={produto.id} className="product-checkbox-item">
                            <input
                              type="checkbox"
                              checked={isSelected}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  if (carouselProdutos.length >= 5) {
                                    toast.warning('Você pode selecionar no máximo 5 produtos!');
                                    return;
                                  }
                                  updateCarousel([...carouselProdutos.map(p => p.id), produto.id]);
                                } else {
                                  updateCarousel(carouselProdutos.filter(p => p.id !== produto.id).map(p => p.id));
                                }
                              }}
                            />
                            <img 
                              src={produto.foto?.startsWith('http') ? produto.foto : `https://www.loucasporbeleza.com.br${produto.foto}`}
                              alt={produto.nome}
                              onError={(e) => e.target.style.display = 'none'}
                            />
                            <span>{produto.nome}</span>
                          </label>
                        );
                      })}
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}

          {activeTab === 'categorias' && (
            <div className="categorias-container">
              <div className="categorias-header">
                <h2>Gerenciar Categorias</h2>
                <div className="categorias-count">{categorias.length} {categorias.length === 1 ? 'categoria' : 'categorias'}</div>
              </div>
              
              <div className="categorias-layout">
                <div className="categoria-form-section">
                  <h3>Cadastrar Nova Categoria</h3>
                  <form onSubmit={handleCategoriaSubmit} className="categoria-form">
                    <div className="form-group">
                      <label htmlFor="categoria-nome">Nome da Categoria *</label>
                      <input
                        type="text"
                        id="categoria-nome"
                        value={categoriaForm.nome}
                        onChange={(e) => setCategoriaForm({...categoriaForm, nome: e.target.value})}
                        required
                        placeholder="Ex: Maquiagem"
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="categoria-descricao">Descrição</label>
                      <textarea
                        id="categoria-descricao"
                        value={categoriaForm.descricao}
                        onChange={(e) => setCategoriaForm({...categoriaForm, descricao: e.target.value})}
                        rows="3"
                        placeholder="Descrição da categoria"
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="categoria-icone">Ícone (emoji)</label>
                      <input
                        type="text"
                        id="categoria-icone"
                        value={categoriaForm.icone}
                        onChange={(e) => setCategoriaForm({...categoriaForm, icone: e.target.value})}
                        placeholder="💄"
                        maxLength="2"
                      />
                    </div>
                    <button type="submit" className="btn-submit" disabled={loading}>
                      {loading ? 'Cadastrando...' : 'Cadastrar Categoria'}
                    </button>
                  </form>

                  <div className="subcategoria-form-block">
                    <h3 className="subcategoria-form-title">Cadastrar Subcategoria</h3>
                    <form onSubmit={(e) => { e.preventDefault(); handleSubcategoriaSubmit(e); }} className="categoria-form subcategoria-form">
                    <div className="form-group">
                      <label htmlFor="subcategoria-categoria">Categoria *</label>
                      <select
                        id="subcategoria-categoria"
                        value={subcategoriaForm.categoria_id}
                        onChange={(e) => setSubcategoriaForm({ ...subcategoriaForm, categoria_id: e.target.value })}
                        required
                        className="form-select"
                      >
                        <option value="">Selecione a categoria</option>
                        {categorias.map(cat => (
                          <option key={cat.id} value={cat.id}>{cat.icone} {cat.nome}</option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group">
                      <label htmlFor="subcategoria-nome">Nome da Subcategoria *</label>
                      <input
                        type="text"
                        id="subcategoria-nome"
                        value={subcategoriaForm.nome}
                        onChange={(e) => setSubcategoriaForm({ ...subcategoriaForm, nome: e.target.value })}
                        required
                        placeholder="Ex: Batons, Sombras, Shampoos"
                      />
                    </div>
                    <button type="submit" className="btn-submit" disabled={loading}>
                      {loading ? 'Cadastrando...' : 'Cadastrar Subcategoria'}
                    </button>
                  </form>
                  </div>
                </div>

                <div className="categorias-list-section">
                  <h3>Categorias Cadastradas</h3>
                  {loadingCategorias ? (
                    <p>Carregando categorias...</p>
                  ) : categorias.length > 0 ? (
                    <div className="categorias-grid-admin">
                      {categorias.map(categoria => (
                        <div key={categoria.id} className="categoria-card-admin">
                          <div className="categoria-header-card">
                            <span className="categoria-icone-display">{categoria.icone || '📦'}</span>
                            <h4>{categoria.nome}</h4>
                          </div>
                          {categoria.descricao && (
                            <p className="categoria-descricao-display">{categoria.descricao}</p>
                          )}
                          <div className="subcategorias-na-categoria">
                            <strong>Subcategorias:</strong>
                            {subcategorias.filter(s => s.categoria_id === categoria.id || s.categoria_id === String(categoria.id)).length === 0 ? (
                              <p className="subcategorias-vazio">Nenhuma</p>
                            ) : (
                              <ul className="subcategorias-lista-admin">
                                {subcategorias.filter(s => s.categoria_id === categoria.id || s.categoria_id === String(categoria.id)).map(sub => (
                                  <li key={sub.id}>
                                    {sub.nome}
                                    <button type="button" onClick={() => handleDeleteSubcategoria(sub.id)} className="btn-delete-sub" title="Remover">×</button>
                                  </li>
                                ))}
                              </ul>
                            )}
                            <form className="form-add-subcategoria" onSubmit={(e) => { e.preventDefault(); const input = e.target.querySelector('input'); handleAddSubcategoriaForCategoria(categoria.id, input); }}>
                              <input type="text" name="subcategoria_nome" placeholder="Nova subcategoria" required />
                              <button type="submit" className="btn-add-sub" disabled={loading}>+</button>
                            </form>
                          </div>
                          <button 
                            onClick={() => handleDeleteCategoria(categoria.id)}
                            className="btn-delete-admin"
                          >
                            🗑️ Deletar
                          </button>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p className="no-data">Nenhuma categoria cadastrada ainda.</p>
                  )}
                </div>
              </div>
            </div>
          )}

          {activeTab === 'vendas' && (
            <div className="vendas-container">
              {vendaStep === null && (
                <>
                  <div className="vendas-header-with-btn">
                    <h2>Vendas e Configurações</h2>
                    <button type="button" className="btn-nova-venda" onClick={iniciarNovaVenda}>Nova venda</button>
                  </div>

                  <div className="vendas-analytics-section">
                    <div className="vendas-analytics-header">
                      <h3>Gráficos de vendas</h3>
                      <div className="vendas-analytics-controls">
                        <select
                          className="vendas-periodo-select"
                          value={periodoGrafico}
                          onChange={(e) => setPeriodoGrafico(e.target.value)}
                        >
                          <option value="dia">Dia</option>
                          <option value="semana">Semana</option>
                          <option value="mes">Mês</option>
                          <option value="semestral">Semestral</option>
                          <option value="anual">Anual</option>
                        </select>
                        <button type="button" className="btn-imprimir-relatorio" onClick={handleImprimirRelatorio}>
                          Imprimir relatório
                        </button>
                      </div>
                    </div>
                    {loadingStatsVendas ? (
                      <p>Carregando gráficos...</p>
                    ) : (
                      <>
                        <div className="vendas-kpis-grid">
                          <div className="vendas-kpi-card">
                            <span className="vendas-kpi-label">Valor total</span>
                            <strong>{formatCurrencyBRL(statsVendas.totalVendas)}</strong>
                          </div>
                          <div className="vendas-kpi-card">
                            <span className="vendas-kpi-label">Pedidos</span>
                            <strong>{statsVendas.totalPedidos}</strong>
                          </div>
                          <div className="vendas-kpi-card">
                            <span className="vendas-kpi-label">Ticket médio</span>
                            <strong>{formatCurrencyBRL(statsVendas.ticketMedio)}</strong>
                          </div>
                        </div>
                        <div className="vendas-graficos-grid">
                          <div className="vendas-grafico-card">
                            <h4>Faturamento por período</h4>
                            {statsVendas.serie.length > 0 ? (
                              <div className="vendas-chart-canvas-wrap">
                                <Bar data={chartPeriodoData} options={chartOptionsPeriodo} />
                              </div>
                            ) : (
                              <p>Sem dados no período.</p>
                            )}
                          </div>
                          <div className="vendas-grafico-card">
                            <h4>Produtos mais vendidos</h4>
                            {statsVendas.topProdutos.length > 0 ? (
                              <div className="vendas-chart-canvas-wrap">
                                <Bar data={chartProdutosData} options={chartOptionsProdutos} />
                              </div>
                            ) : (
                              <p>Sem dados no período.</p>
                            )}
                          </div>
                          <div className="vendas-grafico-card">
                            <h4>Clientes que mais compraram</h4>
                            {statsVendas.topClientes.length > 0 ? (
                              <div className="vendas-chart-canvas-wrap">
                                <Bar data={chartClientesData} options={chartOptionsClientes} />
                              </div>
                            ) : (
                              <p>Sem dados no período.</p>
                            )}
                          </div>
                        </div>
                      </>
                    )}
                  </div>

                  <div className="vendas-config-section">
                    <h3>Pagamento em prazo</h3>
                    <p className="vendas-config-desc">Defina a quantidade máxima de parcelas e o percentual de juros para cada tipo (1x, 2x, 3x, etc.). Pode usar casas decimais (ex.: 1,55 ou 2,25).</p>
                    <form onSubmit={handleSalvarPrazoConfig} className="vendas-prazo-form">
                      <div className="vendas-prazo-row">
                        <label>Máximo de parcelas:</label>
                        <input
                          type="number"
                          min="1"
                          max="24"
                          value={prazoConfig.maxParcelas}
                          onChange={(e) => setPrazoMaxParcelas(e.target.value)}
                        />
                      </div>
                      <div className="vendas-prazo-juros-grid">
                        {Array.from({ length: prazoConfig.maxParcelas }, (_, i) => i + 1).map((n) => (
                          <div key={n} className="vendas-prazo-juros-item">
                            <label>{n}x</label>
                            <input
                                  type="number"
                                  min="0"
                                  max="100"
                                  step="0.01"
                                  value={prazoConfig.juros[String(n)] ?? ''}
                                  onChange={(e) => setPrazoJuros(n, e.target.value)}
                                  placeholder="0"
                                />
                            <span>%</span>
                          </div>
                        ))}
                      </div>
                      <button type="submit" className="btn-submit">Salvar configuração</button>
                    </form>
                  </div>

                  <div className="vendas-pedidos-section">
                    <h3>Pedidos</h3>
                    {loadingPedidos ? (
                      <p>Carregando pedidos...</p>
                    ) : pedidos.length === 0 ? (
                      <p className="vendas-sem-pedidos">Nenhum pedido encontrado.</p>
                    ) : (
                      <div className="vendas-pedidos-layout">
                        <div className="vendas-pedidos-lista">
                          {pedidos.map((pedido) => (
                            <div
                              key={pedido.id}
                              className={`vendas-pedido-card ${pedidoSelecionado?.id === pedido.id ? 'selected' : ''}`}
                              onClick={() => setPedidoSelecionado(pedido)}
                              onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                  e.preventDefault();
                                  setPedidoSelecionado(pedido);
                                }
                              }}
                              role="button"
                              tabIndex={0}
                            >
                            <div className="vendas-pedido-header">
                              <span>Pedido #{pedido.id}</span>
                              <span>{pedido.cliente_nome || pedido.cliente_email}</span>
                              <span className={`vendas-pedido-status status-${pedido.status}`}>{pedidoStatusLabel[pedido.status] || pedido.status}</span>
                              {pedido.created_by_admin && <span className="venda-admin-badge">Venda admin</span>}
                            </div>
                            <div className="vendas-pedido-detalhes">
                              <span>Total: R$ {parseFloat(pedido.total).toFixed(2)}</span>
                              {pedido.forma_pagamento && <span>Pagamento: {pedido.forma_pagamento}</span>}
                              {pedido.parcelas && <span>{pedido.parcelas}x de R$ {parseFloat(pedido.valor_parcela || 0).toFixed(2)}</span>}
                              {pedido.total_com_juros != null && <span>Total c/ juros: R$ {parseFloat(pedido.total_com_juros).toFixed(2)}</span>}
                            </div>
                            {pedido.itens && pedido.itens.length > 0 && (
                              <ul className="vendas-pedido-itens">
                                {pedido.itens.map((item) => (
                                  <li key={item.id}>{item.nome_produto} × {item.quantidade}</li>
                                ))}
                              </ul>
                            )}
                            {(() => {
                              const statusNorm = String(pedido.status || '').toLowerCase().replace(/-/g, '_');
                              const formaNorm = String(pedido.forma_pagamento || '').toLowerCase();
                              const ehPrazoPendente = formaNorm === 'prazo' && (statusNorm === 'aguardando_aprovacao' || statusNorm === 'pendente');
                              const ehSolicitacaoCancelamento = statusNorm === 'cancelamento_solicitado';
                              const ehDoCliente = !pedido.created_by_admin;
                              if (ehSolicitacaoCancelamento && ehDoCliente) {
                                return (
                                  <div className="vendas-pedido-actions">
                                    <button type="button" className="btn-rejeitar" onClick={(e) => { e.stopPropagation(); handleAprovarPedido(pedido.id, 'cancelado'); }}>Cancelar venda</button>
                                    <button type="button" className="btn-aprovar" onClick={(e) => { e.stopPropagation(); handleAprovarPedido(pedido.id, 'confirmado'); }}>Manter venda</button>
                                  </div>
                                );
                              }
                              return ehPrazoPendente && ehDoCliente ? (
                                <div className="vendas-pedido-actions">
                                  <button type="button" className="btn-aprovar" onClick={(e) => { e.stopPropagation(); handleAprovarPedido(pedido.id, 'confirmado'); }}>Aprovar</button>
                                  <button type="button" className="btn-rejeitar" onClick={(e) => { e.stopPropagation(); handleAprovarPedido(pedido.id, 'cancelado'); }}>Rejeitar</button>
                                </div>
                              ) : null;
                            })()}
                            </div>
                          ))}
                        </div>
                        <div className="vendas-pedido-detalhe">
                          {pedidoSelecionado ? (
                            <>
                              <h4>Detalhes do pedido #{pedidoSelecionado.id}</h4>
                              <p><strong>Comprador:</strong> {pedidoSelecionado.cliente_nome || '-'}</p>
                              <p><strong>E-mail:</strong> {pedidoSelecionado.cliente_email || '-'}</p>
                              <p><strong>Status:</strong> {pedidoStatusLabel[pedidoSelecionado.status] || pedidoSelecionado.status}</p>
                              <p><strong>Pagamento:</strong> {pedidoSelecionado.forma_pagamento || '-'}</p>
                              <p><strong>Total:</strong> R$ {parseFloat(pedidoSelecionado.total || 0).toFixed(2)}</p>
                              {pedidoSelecionado.total_com_juros != null && (
                                <p><strong>Total com juros:</strong> R$ {parseFloat(pedidoSelecionado.total_com_juros).toFixed(2)}</p>
                              )}
                              {pedidoSelecionado.parcelas && (
                                <p><strong>Parcelas:</strong> {pedidoSelecionado.parcelas}x de R$ {parseFloat(pedidoSelecionado.valor_parcela || 0).toFixed(2)}</p>
                              )}
                              {pedidoSelecionado.endereco_entrega && (
                                <p><strong>Endereço:</strong> {pedidoSelecionado.endereco_entrega}</p>
                              )}
                              <p><strong>Data:</strong> {pedidoSelecionado.created_at ? new Date(pedidoSelecionado.created_at).toLocaleString('pt-BR') : '-'}</p>
                              <h5>Itens do pedido</h5>
                              {pedidoSelecionado.itens?.length ? (
                                <ul className="vendas-pedido-itens">
                                  {pedidoSelecionado.itens.map((item) => (
                                    <li key={item.id}>
                                      {item.nome_produto} × {item.quantidade}
                                      {item.cor_selecionada ? ` (${item.cor_selecionada})` : ''}
                                    </li>
                                  ))}
                                </ul>
                              ) : (
                                <p>Sem itens cadastrados.</p>
                              )}
                            </>
                          ) : (
                            <p>Selecione um pedido na lista para ver os dados do comprador e os detalhes completos.</p>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </>
              )}

              {vendaStep === 'cliente' && (
                <div className="venda-nova-flow venda-step-cliente">
                  <div className="venda-steps-indicator">
                    <span className="venda-step-ativo">1. Cliente</span>
                    <span className="venda-step-inativo">2. Produtos</span>
                    <span className="venda-step-inativo">3. Pagamento</span>
                  </div>
                  <h2>Selecione o cliente</h2>
                  <p className="venda-step-desc">Busque por nome ou e-mail e escolha o cliente para quem será registrada a venda.</p>
                  <div className="venda-cliente-busca">
                    <input
                      type="text"
                      className="venda-input-busca"
                      placeholder="Buscar por nome ou e-mail..."
                      value={buscaClienteVenda}
                      onChange={(e) => setBuscaClienteVenda(e.target.value)}
                    />
                  </div>
                  <div className="venda-cliente-lista-wrap">
                    <ul className="venda-cliente-lista">
                      {clientesFiltradosVenda.map((c) => (
                        <li
                          key={c.id}
                          className={`venda-cliente-item ${clienteVenda?.id === c.id ? 'selected' : ''}`}
                          onClick={() => setClienteVenda(clienteVenda?.id === c.id ? null : c)}
                        >
                          <span className="venda-cliente-nome">{c.nome}</span>
                          <span className="venda-cliente-email">{c.email}</span>
                        </li>
                      ))}
                    </ul>
                    {clientesFiltradosVenda.length === 0 && <p className="venda-lista-vazia">Nenhum cliente encontrado.</p>}
                  </div>
                  {clienteVenda && (
                    <div className="venda-cliente-selecionado">
                      <strong>Cliente selecionado:</strong> {clienteVenda.nome} — {clienteVenda.email}
                    </div>
                  )}
                  <div className="venda-step-actions">
                    <button type="button" className="btn-continuar" onClick={() => clienteVenda && setVendaStep('carrinho')} disabled={!clienteVenda}>Continuar para produtos</button>
                    <button type="button" className="btn-cancelar-venda" onClick={cancelarNovaVenda}>Cancelar e começar de novo</button>
                  </div>
                </div>
              )}

              {vendaStep === 'carrinho' && (
                <div className="venda-nova-flow venda-step-produtos">
                  <div className="venda-steps-indicator">
                    <span className="venda-step-ok">1. Cliente ✓</span>
                    <span className="venda-step-ativo">2. Produtos</span>
                    <span className="venda-step-inativo">3. Pagamento</span>
                  </div>
                  <h2>Produtos — {clienteVenda?.nome}</h2>
                  <p className="venda-step-desc">Filtre, escolha os produtos e adicione ao carrinho como se fosse o cliente fazendo a compra.</p>

                  <div className="venda-carrinho-layout">
                    <div className="venda-produtos-area">
                      <div className="venda-filtros">
                        <select
                          className="venda-filtro-categoria"
                          value={filtroCategoriaVenda}
                          onChange={(e) => setFiltroCategoriaVenda(e.target.value)}
                        >
                          <option value="">Todas as categorias</option>
                          {categoriasVenda.map((cat) => (
                            <option key={cat.id} value={cat.id}>{cat.nome}</option>
                          ))}
                        </select>
                        <input
                          type="text"
                          className="venda-filtro-busca"
                          placeholder="Buscar produto por nome..."
                          value={filtroBuscaVenda}
                          onChange={(e) => setFiltroBuscaVenda(e.target.value)}
                        />
                      </div>

                      {loadingProdutosVenda ? (
                        <p className="venda-loading">Carregando produtos...</p>
                      ) : (
                        <div className="venda-produtos-grid">
                          {produtosFiltradosVenda.map((p) => {
                            const foto = (p.fotos && p.fotos[0]) || p.foto;
                            const qty = Math.max(1, parseInt(qtyParaAdicionarVenda[p.id], 10) || 1);
                            return (
                              <div key={p.id} className="venda-produto-card">
                                <div className="venda-produto-card-img">
                                  <img src={getImageUrl(foto)} alt={p.nome} />
                                </div>
                                <div className="venda-produto-card-body">
                                  <span className="venda-produto-card-nome">{p.nome}</span>
                                  <span className="venda-produto-card-preco">R$ {parseFloat(p.preco).toFixed(2)}</span>
                                  <div className="venda-produto-card-add">
                                    <input
                                      type="number"
                                      min="1"
                                      value={qtyParaAdicionarVenda[p.id] ?? 1}
                                      onChange={(e) => setQtyAdicionarVenda(p.id, e.target.value)}
                                    />
                                    <button type="button" className="btn-add-cart" onClick={() => adicionarAoCarrinhoVenda(p, qty)}>Adicionar ao carrinho</button>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      )}
                      {!loadingProdutosVenda && produtosFiltradosVenda.length === 0 && (
                        <p className="venda-lista-vazia">Nenhum produto encontrado com os filtros aplicados.</p>
                      )}
                    </div>

                    <div className="venda-carrinho-resumo">
                      <h3>Carrinho ({carrinhoVenda.length} {carrinhoVenda.length === 1 ? 'item' : 'itens'})</h3>
                      {carrinhoVenda.length === 0 ? (
                        <p className="venda-carrinho-vazio">Carrinho vazio. Adicione produtos à esquerda.</p>
                      ) : (
                        <>
                          <ul className="venda-carrinho-itens">
                            {carrinhoVenda
                              .map((item, idx) => ({ item, idx }))
                              .sort((a, b) =>
                                String(a.item.produto?.nome || '').localeCompare(
                                  String(b.item.produto?.nome || ''),
                                  'pt-BR',
                                  { sensitivity: 'base', numeric: true }
                                )
                              )
                              .map(({ item, idx }) => {
                                const foto = (item.produto?.fotos && item.produto.fotos[0]) || item.produto?.foto;
                                return (
                                  <li key={`${item.produto?.id}-${idx}`} className="venda-carrinho-item">
                                    <div className="venda-carrinho-item-img">
                                      <img src={getImageUrl(foto)} alt={item.produto?.nome} />
                                    </div>
                                    <div className="venda-carrinho-item-info">
                                      <span className="venda-carrinho-item-nome">{item.produto?.nome}</span>
                                      <span className="venda-carrinho-item-preco">R$ {parseFloat(item.produto?.preco || 0).toFixed(2)} un.</span>
                                      <div className="venda-carrinho-item-qty">
                                        <button type="button" onClick={() => alterarQtdCarrinhoVenda(idx, (item.quantidade || 1) - 1)} aria-label="Menos">−</button>
                                        <input type="number" min="1" value={item.quantidade || 1} onChange={(e) => alterarQtdCarrinhoVenda(idx, e.target.value)} />
                                        <button type="button" onClick={() => alterarQtdCarrinhoVenda(idx, (item.quantidade || 1) + 1)} aria-label="Mais">+</button>
                                      </div>
                                      <span className="venda-carrinho-item-subtotal">R$ {(parseFloat(item.produto?.preco || 0) * (item.quantidade || 1)).toFixed(2)}</span>
                                    </div>
                                    <button type="button" className="btn-remove-cart" onClick={() => removerDoCarrinhoVenda(idx)} title="Remover">×</button>
                                  </li>
                                );
                              })}
                          </ul>
                          <div className="venda-carrinho-total-wrap">
                            <span className="venda-carrinho-total">Total: R$ {totalCarrinhoVenda.toFixed(2)}</span>
                          </div>
                          <div className="venda-carrinho-btns">
                            <button type="button" className="btn-continuar" onClick={finalizarParaPagamento}>Finalizar venda</button>
                            <button type="button" className="btn-voltar-venda" onClick={() => setVendaStep('cliente')}>Voltar ao cliente</button>
                            <button type="button" className="btn-cancelar-venda" onClick={cancelarNovaVenda}>Cancelar e começar de novo</button>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {vendaStep === 'pagamento' && (
                <div className="venda-nova-flow venda-pagamento-step">
                  <div className="venda-steps-indicator">
                    <span className="venda-step-ok">1. Cliente ✓</span>
                    <span className="venda-step-ok">2. Produtos ✓</span>
                    <span className="venda-step-ativo">3. Pagamento</span>
                  </div>
                  <h2>Forma de pagamento</h2>
                  <p className="venda-total-label">Total da venda: R$ {totalCarrinhoVenda.toFixed(2)}</p>

                  <div className="venda-pagamento-opcoes">
                    <label className="venda-pagamento-tipo">
                      <input type="radio" name="pagamentoTipo" checked={pagamentoTipo === 'normal'} onChange={() => setPagamentoTipo('normal')} />
                      <span>Normal</span>
                    </label>
                    <p className="venda-pagamento-desc">Venda normal — Pix, Dinheiro, Débito ou Crédito.</p>
                    {pagamentoTipo === 'normal' && (
                      <div className="venda-formas-normal">
                        {['pix', 'dinheiro', 'debito', 'credito'].map((f) => (
                          <label key={f} className="venda-forma-option">
                            <input type="radio" name="formaNormal" value={f} checked={formaNormal === f} onChange={() => setFormaNormal(f)} />
                            <span>{f === 'pix' ? 'Pix' : f === 'dinheiro' ? 'Dinheiro' : f === 'debito' ? 'Débito' : 'Crédito'}</span>
                          </label>
                        ))}
                      </div>
                    )}

                    <label className="venda-pagamento-tipo">
                      <input type="radio" name="pagamentoTipo" checked={pagamentoTipo === 'prazo'} onChange={() => setPagamentoTipo('prazo')} />
                      <span>Prazo</span>
                    </label>
                    <p className="venda-pagamento-desc">Entrada (opcional) + parcelas. Entrada pode ser Pix, Dinheiro ou Débito. Parcelas a partir da data escolhida.</p>
                    {pagamentoTipo === 'prazo' && (
                      <div className="venda-prazo-form">
                        <div className="venda-prazo-entrada">
                          <label>Entrada (R$)</label>
                          <input type="number" min="0" step="0.01" value={prazoEntrada} onChange={(e) => setPrazoEntrada(e.target.value)} />
                          {parseFloat(prazoEntrada) > 0 && (
                            <select value={prazoFormaEntrada} onChange={(e) => setPrazoFormaEntrada(e.target.value)}>
                              <option value="pix">Pix</option>
                              <option value="dinheiro">Dinheiro</option>
                              <option value="debito">Débito</option>
                            </select>
                          )}
                        </div>
                        <div className="venda-prazo-parcelas">
                          <label>Número de parcelas</label>
                          <select value={prazoParcelas} onChange={(e) => setPrazoParcelas(parseInt(e.target.value, 10))}>
                            {Array.from({ length: prazoConfig.maxParcelas }, (_, i) => i + 1).map((n) => (
                              <option key={n} value={n}>{n}x</option>
                            ))}
                          </select>
                        </div>
                        <div className="venda-prazo-data">
                          <label>Data da primeira parcela</label>
                          <input type="date" value={prazoDataPrimeira} onChange={(e) => setPrazoDataPrimeira(e.target.value)} />
                        </div>
                        {prazoDataPrimeira && prazoParcelas >= 1 && (() => {
                          const juros = parseDecimalBr(prazoConfig.juros[String(prazoParcelas)]);
                          const totalComJuros = Math.round(totalCarrinhoVenda * (1 + juros / 100) * 100) / 100;
                          const entrada = Math.max(0, parseFloat(prazoEntrada) || 0);
                          const restante = Math.round((totalComJuros - entrada) * 100) / 100;
                          const valorParcela = prazoParcelas > 0 ? Math.round((restante / prazoParcelas) * 100) / 100 : restante;
                          const datas = [];
                          let d = new Date(prazoDataPrimeira + 'T12:00:00');
                          for (let i = 0; i < prazoParcelas; i++) {
                            datas.push(d.toLocaleDateString('pt-BR'));
                            d.setMonth(d.getMonth() + 1);
                          }
                          return (
                            <div className="venda-prazo-tabela">
                              <p><strong>Total com juros ({juros}%): R$ {totalComJuros.toFixed(2)}</strong></p>
                              {entrada > 0 && <p>Entrada: R$ {entrada.toFixed(2)} ({prazoFormaEntrada})</p>}
                              <p>Parcelas:</p>
                              <ul>
                                {datas.map((data, i) => (
                                  <li key={i}>Parcela {i + 1}: {data} — R$ {valorParcela.toFixed(2)}</li>
                                ))}
                              </ul>
                            </div>
                          );
                        })()}
                      </div>
                    )}
                  </div>

                  <div className="venda-step-actions venda-confirmar">
                    <button type="button" className="btn-confirmar-venda" onClick={confirmarVenda} disabled={loadingVenda}>
                      {loadingVenda ? 'Processando...' : 'Confirmar venda'}
                    </button>
                    <button type="button" className="btn-voltar-venda" onClick={() => setVendaStep('carrinho')}>Voltar aos produtos</button>
                    <button type="button" className="btn-cancelar-venda" onClick={cancelarNovaVenda}>Cancelar e começar de novo</button>
                  </div>
                </div>
              )}
            </div>
          )}

          {activeTab === 'aprazo' && <AreaPrazoAdmin />}

          {activeTab === 'graficos' && (
            <div className="vendas-container">
              <div className="vendas-header-with-btn">
                <h2>Gráficos de Vendas</h2>
                <div className="vendas-header-actions">
                  <button type="button" className="btn-nova-venda" onClick={abrirRelatorioImpresso}>Relatório Impresso</button>
                  <button type="button" className="btn-nova-venda" onClick={() => setActiveTab('vendas')}>Ir para Vendas</button>
                  <button type="button" className="btn-nova-venda" onClick={abrirGraficosAprazo}>
                    Gráficos e relatório A Prazo
                  </button>
                </div>
              </div>
              <div className="vendas-analytics-section">
                <div className="vendas-analytics-header">
                  <h3>Desempenho por período</h3>
                  <div className="vendas-analytics-controls">
                    <select
                      className="vendas-periodo-select"
                      value={periodoGrafico}
                      onChange={(e) => setPeriodoGrafico(e.target.value)}
                    >
                      <option value="dia">Dia</option>
                      <option value="semana">Semana</option>
                      <option value="mes">Mês</option>
                      <option value="semestral">Semestral</option>
                      <option value="anual">Anual</option>
                    </select>
                    <button type="button" className="btn-imprimir-relatorio" onClick={handleImprimirRelatorio}>
                      Imprimir relatório
                    </button>
                  </div>
                </div>
                {loadingStatsVendas ? (
                  <p>Carregando gráficos...</p>
                ) : (
                  <>
                    <div className="vendas-kpis-grid">
                      <div className="vendas-kpi-card">
                        <span className="vendas-kpi-label">Valor total</span>
                        <strong>{formatCurrencyBRL(statsVendas.totalVendas)}</strong>
                      </div>
                      <div className="vendas-kpi-card">
                        <span className="vendas-kpi-label">Pedidos</span>
                        <strong>{statsVendas.totalPedidos}</strong>
                      </div>
                      <div className="vendas-kpi-card">
                        <span className="vendas-kpi-label">Ticket médio</span>
                        <strong>{formatCurrencyBRL(statsVendas.ticketMedio)}</strong>
                      </div>
                    </div>
                    <div className="vendas-graficos-grid">
                      <div className="vendas-grafico-card">
                        <h4>Faturamento por período</h4>
                        {statsVendas.serie.length > 0 ? (
                              <div className="vendas-chart-canvas-wrap">
                                <Bar data={chartPeriodoData} options={chartOptionsPeriodo} />
                              </div>
                            ) : (
                              <p>Sem dados no período.</p>
                            )}
                      </div>
                      <div className="vendas-grafico-card">
                        <h4>Produtos mais vendidos</h4>
                        {statsVendas.topProdutos.length > 0 ? (
                              <div className="vendas-chart-canvas-wrap">
                                <Bar data={chartProdutosData} options={chartOptionsProdutos} />
                              </div>
                            ) : (
                              <p>Sem dados no período.</p>
                            )}
                      </div>
                      <div className="vendas-grafico-card">
                        <h4>Clientes que mais compraram</h4>
                        {statsVendas.topClientes.length > 0 ? (
                              <div className="vendas-chart-canvas-wrap">
                                <Bar data={chartClientesData} options={chartOptionsClientes} />
                              </div>
                            ) : (
                              <p>Sem dados no período.</p>
                            )}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          )}

          {activeTab === 'graficosAprazo' && (
            <div className="vendas-container">
              <div className="vendas-header-with-btn">
                <h2>Movimentação — Vendas a prazo (loja)</h2>
                <div className="vendas-header-actions">
                  <button type="button" className="btn-nova-venda" onClick={() => setActiveTab('aprazo')}>
                    Ir para A Prazo
                  </button>
                  <button type="button" className="btn-nova-venda" onClick={() => setActiveTab('graficos')}>
                    Gráficos do e-commerce
                  </button>
                  <button type="button" className="btn-nova-venda" onClick={togglePainelVendasAprazoPeriodo}>
                    Vendas por período
                  </button>
                </div>
              </div>
              {painelPeriodoVendasAprazoAberto && (
                <div className="aprazo-periodo-vendas-panel">
                  <p className="aprazo-periodo-vendas-intro">
                    Escolha a <strong>data inicial</strong> e a <strong>data final</strong> da venda (registro no painel A Prazo) e clique em <strong>Listar vendas</strong>. Só aparecem vendas nesse intervalo.
                  </p>
                  <div className="aprazo-periodo-vendas-form">
                    <label className="aprazo-periodo-vendas-label">
                      <span>Data inicial</span>
                      <input
                        type="date"
                        value={periodoVendasAprazoIni}
                        onChange={(e) => setPeriodoVendasAprazoIni(e.target.value)}
                      />
                    </label>
                    <label className="aprazo-periodo-vendas-label">
                      <span>Data final</span>
                      <input
                        type="date"
                        value={periodoVendasAprazoFim}
                        onChange={(e) => setPeriodoVendasAprazoFim(e.target.value)}
                      />
                    </label>
                    <div className="aprazo-periodo-vendas-btns">
                      <button type="button" className="btn-nova-venda" onClick={buscarVendasAprazoPorPeriodo} disabled={loadingVendasAprazoPeriodo || loadingPdfAprazoPeriodo}>
                        {loadingVendasAprazoPeriodo ? 'Carregando…' : 'Listar vendas'}
                      </button>
                      <button type="button" className="btn-nova-venda" onClick={gerarPdfVendasAprazoPeriodo} disabled={loadingPdfAprazoPeriodo || loadingVendasAprazoPeriodo}>
                        {loadingPdfAprazoPeriodo ? 'Gerando PDF…' : 'Gerar PDF'}
                      </button>
                    </div>
                  </div>
                  {loadingVendasAprazoPeriodo && <p className="aprazo-periodo-vendas-msg">Carregando vendas…</p>}
                  {!loadingVendasAprazoPeriodo && vendasAprazoPeriodoConsultado && periodoVendasAprazoIni && periodoVendasAprazoFim && (
                    <p className="aprazo-periodo-vendas-intervalo">
                      Somente vendas com data de registro entre{' '}
                      <strong>{new Date(`${periodoVendasAprazoIni}T12:00:00`).toLocaleDateString('pt-BR')}</strong>
                      {' '}e <strong>{new Date(`${periodoVendasAprazoFim}T12:00:00`).toLocaleDateString('pt-BR')}</strong>
                      {' '}(inclusive).
                    </p>
                  )}
                  {!loadingVendasAprazoPeriodo && vendasAprazoPeriodoConsultado && vendasAprazoListaPeriodo.length > 0 && (
                    <>
                      <p className="aprazo-periodo-vendas-total">
                        Total vendido no período:{' '}
                        <strong>
                          {formatCurrencyBRL(
                            vendasAprazoListaPeriodo.reduce((acc, v) => acc + parseMoney(v.total), 0)
                          )}
                        </strong>
                        {' '}({vendasAprazoListaPeriodo.length}{' '}
                        {vendasAprazoListaPeriodo.length === 1 ? 'venda' : 'vendas'})
                      </p>
                      <div className="clientes-table aprazo-periodo-vendas-table-wrap">
                        <table>
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Data</th>
                              <th>Total</th>
                              <th>Pago</th>
                              <th>Saldo</th>
                            </tr>
                          </thead>
                          <tbody>
                            {vendasAprazoListaPeriodo.map((v) => {
                              const dataStr = v.created_at
                                ? new Date(v.created_at).toLocaleString('pt-BR', {
                                    dateStyle: 'short',
                                    timeStyle: 'short'
                                  })
                                : '—';
                              return (
                                <tr key={v.id}>
                                  <td>{v.id}</td>
                                  <td>{dataStr}</td>
                                  <td>{formatCurrencyBRL(v.total)}</td>
                                  <td>{formatCurrencyBRL(v.pago_total)}</td>
                                  <td>{formatCurrencyBRL(v.saldo)}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </>
                  )}
                  {!loadingVendasAprazoPeriodo && vendasAprazoPeriodoConsultado && vendasAprazoListaPeriodo.length === 0 && (
                    <p className="aprazo-periodo-vendas-msg">Nenhuma venda a prazo neste período.</p>
                  )}
                </div>
              )}
              <div className="vendas-analytics-section">
                <div className="vendas-analytics-header">
                  <h3>Período e relatório</h3>
                  <div className="vendas-analytics-controls">
                    <select
                      className="vendas-periodo-select"
                      value={periodoGraficoAprazo}
                      onChange={(e) => setPeriodoGraficoAprazo(e.target.value)}
                    >
                      <option value="dia">Dia</option>
                      <option value="semana">Semana</option>
                      <option value="mes">Mês</option>
                      <option value="semestral">Semestral</option>
                      <option value="anual">Anual</option>
                    </select>
                    <button type="button" className="btn-imprimir-relatorio" onClick={handleImprimirRelatorioAprazo}>
                      Imprimir relatório A Prazo
                    </button>
                  </div>
                </div>
                {loadingStatsAprazo ? (
                  <p>Carregando gráficos a prazo...</p>
                ) : (
                  <>
                    <p className="vendas-aprazo-stats-intro">
                      Dados das vendas a prazo cadastradas no painel <strong>A Prazo</strong> (pagamentos lançados, novas vendas no período e posição atual em aberto).
                    </p>
                    <div className="vendas-kpis-grid vendas-kpis-grid--aprazo">
                      <div className="vendas-kpi-card">
                        <span className="vendas-kpi-label">Recebido no período</span>
                        <strong>{formatCurrencyBRL(statsAprazo.totalPagamentosRecebidos)}</strong>
                      </div>
                      <div className="vendas-kpi-card">
                        <span className="vendas-kpi-label">Novas vendas (R$)</span>
                        <strong>{formatCurrencyBRL(statsAprazo.totalNovasVendasValor)}</strong>
                      </div>
                      <div className="vendas-kpi-card">
                        <span className="vendas-kpi-label">Vendas registradas</span>
                        <strong>{statsAprazo.vendasRegistradasNoPeriodo}</strong>
                      </div>
                      <div className="vendas-kpi-card">
                        <span className="vendas-kpi-label">Saldo em aberto (hoje)</span>
                        <strong>{formatCurrencyBRL(statsAprazo.saldoEmAberto)}</strong>
                      </div>
                      <div className="vendas-kpi-card">
                        <span className="vendas-kpi-label">Vendas em aberto</span>
                        <strong>{statsAprazo.vendasAbertasCount}</strong>
                      </div>
                    </div>
                    <div className="vendas-graficos-grid">
                      <div className="vendas-grafico-card">
                        <h4>Pagamentos recebidos por intervalo</h4>
                        {statsAprazo.seriePagamentos.length > 0 ? (
                          <div className="vendas-chart-canvas-wrap">
                            <Bar data={chartAprazoPagamentosData} options={chartOptionsAprazoMoney} />
                          </div>
                        ) : (
                          <p>Sem pagamentos no período.</p>
                        )}
                      </div>
                      <div className="vendas-grafico-card">
                        <h4>Novas vendas registradas (valor total) por intervalo</h4>
                        {statsAprazo.serieNovasVendas.length > 0 ? (
                          <div className="vendas-chart-canvas-wrap">
                            <Bar data={chartAprazoNovasVendasData} options={chartOptionsAprazoMoney} />
                          </div>
                        ) : (
                          <p>Sem vendas registradas no período.</p>
                        )}
                      </div>
                      <div className="vendas-grafico-card">
                        <h4>Recebimentos por método</h4>
                        {statsAprazo.porMetodoPagamento.length > 0 ? (
                          <div className="vendas-chart-canvas-wrap vendas-chart-canvas-wrap--wide">
                            <Bar data={chartAprazoMetodosData} options={chartOptionsAprazoMetodos} />
                          </div>
                        ) : (
                          <p>Sem pagamentos no período.</p>
                        )}
                      </div>
                      <div className="vendas-grafico-card">
                        <h4>Clientes — maiores recebimentos</h4>
                        {statsAprazo.topClientesRecebimentos.length > 0 ? (
                          <div className="vendas-chart-canvas-wrap">
                            <Bar data={chartAprazoClientesData} options={chartOptionsAprazoMoney} />
                          </div>
                        ) : (
                          <p>Sem dados.</p>
                        )}
                      </div>
                      <div className="vendas-grafico-card">
                        <h4>Produtos mais vendidos (a prazo no período)</h4>
                        {statsAprazo.topProdutos.length > 0 ? (
                          <div className="vendas-chart-canvas-wrap">
                            <Bar data={chartAprazoProdutosData} options={chartOptionsProdutos} />
                          </div>
                        ) : (
                          <p>Sem dados.</p>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          )}

          {activeTab === 'relatorioImpresso' && (
            <div className="vendas-container">
              <div className="vendas-header-with-btn">
                <h2>Relatório Impresso</h2>
                <div className="vendas-header-actions">
                  <button type="button" className="btn-nova-venda" onClick={() => setActiveTab('graficos')}>Voltar para Gráficos</button>
                  <button type="button" className="btn-nova-venda" onClick={abrirGraficosAprazo}>
                    Gráficos e relatório A Prazo
                  </button>
                </div>
              </div>

              <div className="vendas-analytics-section relatorio-preview-section">
                <div className="vendas-analytics-header">
                  <h3>Prévia do relatório</h3>
                  <div className="vendas-analytics-controls">
                    <select
                      className="vendas-periodo-select"
                      value={periodoGrafico}
                      onChange={(e) => setPeriodoGrafico(e.target.value)}
                    >
                      <option value="dia">Dia</option>
                      <option value="semana">Semana</option>
                      <option value="mes">Mês</option>
                      <option value="semestral">Semestral</option>
                      <option value="anual">Anual</option>
                    </select>
                    <button type="button" className="btn-imprimir-relatorio" onClick={handleImprimirRelatorio}>
                      Imprimir relatório
                    </button>
                  </div>
                </div>

                {loadingStatsVendas ? (
                  <p>Carregando dados do relatório...</p>
                ) : (
                  <>
                    <div className="vendas-kpis-grid">
                      <div className="vendas-kpi-card">
                        <span className="vendas-kpi-label">Valor total</span>
                        <strong>{formatCurrencyBRL(statsVendas.totalVendas)}</strong>
                      </div>
                      <div className="vendas-kpi-card">
                        <span className="vendas-kpi-label">Pedidos</span>
                        <strong>{statsVendas.totalPedidos}</strong>
                      </div>
                      <div className="vendas-kpi-card">
                        <span className="vendas-kpi-label">Ticket médio</span>
                        <strong>{formatCurrencyBRL(statsVendas.ticketMedio)}</strong>
                      </div>
                    </div>

                    <div className="relatorio-tabela-wrap">
                      <h4>Faturamento por período</h4>
                      <table className="relatorio-tabela">
                        <thead>
                          <tr>
                            <th>Período</th>
                            <th>Total vendido</th>
                          </tr>
                        </thead>
                        <tbody>
                          {statsVendas.serie.length > 0 ? statsVendas.serie.map((item, idx) => (
                            <tr key={`serie-${idx}`}>
                              <td>{item.label}</td>
                              <td>{formatCurrencyBRL(item.total)}</td>
                            </tr>
                          )) : (
                            <tr>
                              <td colSpan={2}>Sem dados no período.</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>

                    <div className="relatorio-tabela-wrap">
                      <h4>Produtos mais vendidos</h4>
                      <table className="relatorio-tabela">
                        <thead>
                          <tr>
                            <th>Produto</th>
                            <th>Quantidade</th>
                            <th>Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          {statsVendas.topProdutos.length > 0 ? statsVendas.topProdutos.map((item, idx) => (
                            <tr key={`prod-${idx}`}>
                              <td>{item.nome_produto}</td>
                              <td>{Number(item.quantidade || 0)}</td>
                              <td>{formatCurrencyBRL(item.total)}</td>
                            </tr>
                          )) : (
                            <tr>
                              <td colSpan={3}>Sem dados no período.</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>

                    <div className="relatorio-tabela-wrap">
                      <h4>Clientes que mais compraram</h4>
                      <table className="relatorio-tabela">
                        <thead>
                          <tr>
                            <th>Cliente</th>
                            <th>E-mail</th>
                            <th>Pedidos</th>
                            <th>Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          {statsVendas.topClientes.length > 0 ? statsVendas.topClientes.map((item, idx) => (
                            <tr key={`cli-${idx}`}>
                              <td>{item.nome || '-'}</td>
                              <td>{item.email || '-'}</td>
                              <td>{Number(item.pedidos || 0)}</td>
                              <td>{formatCurrencyBRL(item.total)}</td>
                            </tr>
                          )) : (
                            <tr>
                              <td colSpan={4}>Sem dados no período.</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DashboardAdmin;

